import React, { useEffect, useState, useRef } from 'react';
import NavBar from '../../../components/NavBar';
import { RiFileExcel2Line } from 'react-icons/ri';
import { FaArrowRight } from 'react-icons/fa6';
import { FaArrowLeft } from 'react-icons/fa6';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { IoMdClipboard } from 'react-icons/io';
import NewInvestigacao from '../../../components/newNoteLayout/investigacao/newInvestigacao';
import NewClassificacao from '../../../components/newNoteLayout/classificacao/newClassificacao';
import NewNotificacao from '../../../components/newNoteLayout/notificacao/newNotificacao';
import NewAvaliacao from '../../../components/newNoteLayout/avaliacao/newAvaliacao';
import NewConcludedView from '../../../components/newNoteLayout/avaliacao/NewConcludedView';
import NewNotificacaoPreenchido from '../../../components/newNoteLayout/notificacao/newNotificacaoPreenchido';
import NewClassificacaoPreenchido from '../../../components/newNoteLayout/classificacao/newClassificacaoPreenchido';
import NewInvestigacaoPreenchido from '../../../components/newNoteLayout/investigacao/newInvestigacaoPreenchido';
import NewNotificacaoPDF from '../../../components/newNoteLayout/notificacao/newNotificacaoPDF';
import NewClassificacaoPDF from '../../../components/newNoteLayout/classificacao/newClassificacaoPDF';
import NewInvestigacaoPDF from '../../../components/newNoteLayout/investigacao/newInvestigacaoPDF';
import { generatePDF } from '../../../components/newNoteLayout/pdfGenerator';

import { IoMdClose } from 'react-icons/io';
import { FiPlus } from 'react-icons/fi';
import { MdArrowBackIosNew } from 'react-icons/md';

import {
	requestNewUnits,
	requestListNotes,
	requestNotesByInv,
	requestAllInvestigations,
	requestExcelExport,
	requestInvestigators,
	requestAtribuidos,
	requestDesativarInv,
	requestAtribuirInv,
	requestClassDiscard,
	requestPAResume,
} from '../../../services/requests';
import Relogio from '../../../images/NotifyAvaliationImages/relogio.png';
import Lupa from '../../../images/NotifyAvaliationImages/lupa.png';
import Check from '../../../images/NotifyAvaliationImages/check.png';
import Prancheta from '../../../images/NotifyAvaliationImages/prancheta.png';
import logo from '../../../images/bluelogo.png';
import { LuClipboardCheck } from 'react-icons/lu';
import { FaRegFilePdf, FaSearch } from 'react-icons/fa';
import { IoMdEye } from 'react-icons/io';
import { FaFilter } from 'react-icons/fa';
import { GoDotFill } from 'react-icons/go';
import { useNavigate } from 'react-router-dom';
import Loading from '../../../components/Loading';
import { HiOutlinePencilSquare } from 'react-icons/hi2';
import { MdOutlinePersonSearch } from 'react-icons/md';
import ClassInvForm from '../../../components/ClassInvForm';
import Cookies from 'js-cookie';

const workflowStatus = (status) =>
	status === 'REINVESTIGACAO' ? 'CLASSIFICADO' : status;

const getUserCookie = () => {
	const rawUser = Cookies.get('user');
	return rawUser ? JSON.parse(rawUser) : {};
};

const normalizeAccessValue = (value = '') =>
	String(value)
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.trim()
		.toLowerCase();

const getPermissions = (user = {}) =>
	Array.isArray(user?.permissao)
		? user.permissao
		: user?.permissao
			? [user.permissao]
			: [];

const hasPermission = (user = {}, permission) =>
	getPermissions(user).some(
		(currentPermission) =>
			normalizeAccessValue(currentPermission) ===
			normalizeAccessValue(permission),
	);

const isSubhueUser = (user = {}) =>
	normalizeAccessValue(user?.unidade).includes('subhue') ||
	normalizeAccessValue(user?.cargo).includes('subhue');

const hasIncidentWorkflowPermission = (user = {}) =>
	hasPermission(user, 'Classificadores') ||
	hasPermission(user, 'Investigadores');

const isSubhueReadOnlyUser = (user = {}) =>
	isSubhueUser(user) && !hasIncidentWorkflowPermission(user);

const hasGestorAndInvestigadorPermissions = (user = {}) =>
	hasPermission(user, 'Gestores') && hasPermission(user, 'Investigadores');

const hasGestorOnlyFlowPermission = (user = {}) => {
	const permissions = getPermissions(user);
	return (
		permissions.includes('Gestores') &&
		!permissions.includes('Classificadores') &&
		!permissions.includes('Investigadores')
	);
};

const sameInvestigator = (investigator = {}, user = {}) => {
	const investigatorValues = [
		investigator?.username,
		investigator?.userName,
		investigator?.nome,
		investigator?.email,
	]
		.filter(Boolean)
		.map((value) => String(value).trim().toLowerCase());

	const userValues = [user?.userName, user?.username, user?.nome, user?.email]
		.filter(Boolean)
		.map((value) => String(value).trim().toLowerCase());

	return investigatorValues.some((value) => userValues.includes(value));
};

const ReadOnlyPdfButton = ({ notificacao, status }) => {
	const notificacaoRef = useRef(null);
	const classificacaoRef = useRef(null);
	const investigacaoRef = useRef(null);
	const readyPdfSectionsRef = useRef(new Set());
	const [generatingPdf, setGeneratingPdf] = useState(false);
	const [downloadedPdf, setDownloadedPdf] = useState(false);
	const requiredPdfSections = [
		'notificacao',
		...(['CLASSIFICADO', 'INVESTIGADO'].includes(status)
			? ['classificacao']
			: []),
		...(status === 'INVESTIGADO' ? ['investigacao'] : []),
	];

	useEffect(() => {
		readyPdfSectionsRef.current = new Set();
		setDownloadedPdf(false);
	}, [notificacao?.protocolo, status]);

	const markPdfSectionReady = (section) => {
		readyPdfSectionsRef.current.add(section);
	};

	const waitForPdfSections = async () => {
		const startedAt = Date.now();
		while (
			requiredPdfSections.some(
				(section) => !readyPdfSectionsRef.current.has(section),
			) &&
			Date.now() - startedAt < 15000
		) {
			await new Promise((resolve) => setTimeout(resolve, 100));
		}
	};

	const handleGeneratePdf = async () => {
		setGeneratingPdf(true);
		setDownloadedPdf(false);

		try {
			const refs = [notificacaoRef];
			if (['CLASSIFICADO', 'INVESTIGADO'].includes(status)) {
				refs.push(classificacaoRef);
			}
			if (status === 'INVESTIGADO') {
				refs.push(investigacaoRef);
			}

			await waitForPdfSections();
			await new Promise((resolve) => requestAnimationFrame(resolve));
			await generatePDF(
				refs,
				`${notificacao?.protocolo || 'notificacao'}.pdf`,
			);
			setDownloadedPdf(true);
		} finally {
			setGeneratingPdf(false);
		}
	};

	return (
		<>
			<div className='w-full flex justify-start'>
				<button
					type='button'
					disabled={generatingPdf}
					onClick={handleGeneratePdf}
					className='enabled:bg-[#E3E3E3] max-h-[40px] text-[#a3a3a3] enabled:text-[#757575] flex bg-[#d3d3d3] py-2 px-3 rounded-md enabled:hover:bg-[#757575] enabled:hover:text-[#f0f0f0] transition-all duration-200 focus:outline-none font-semibold gap-2 items-center'>
					{generatingPdf ? (
						<>
							<span className='inline-block w-4 h-4 border-2 border-t-transparent border-current rounded-full animate-spin' />
							<span>Gerando PDF...</span>
						</>
					) : downloadedPdf ? (
						<span>Download Concluído</span>
					) : (
						<>
							<FaRegFilePdf className='w-[18px] h-auto' />
							<span>Gerar PDF</span>
						</>
					)}
				</button>
			</div>

			<div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
				<NewNotificacaoPDF
					ref={notificacaoRef}
					notificacao={notificacao}
					onReady={() => markPdfSectionReady('notificacao')}
				/>
				{['CLASSIFICADO', 'INVESTIGADO'].includes(status) && (
					<NewClassificacaoPDF
						ref={classificacaoRef}
						notificacao={notificacao}
						onReady={() => markPdfSectionReady('classificacao')}
					/>
				)}
				{status === 'INVESTIGADO' && (
					<NewInvestigacaoPDF
						ref={investigacaoRef}
						notificacao={notificacao}
						onReady={() => markPdfSectionReady('investigacao')}
					/>
				)}
			</div>
		</>
	);
};

const ReadOnlyIncidentView = ({ notificacao }) => {
	const status = workflowStatus(notificacao?.status);

	if (status === 'CONCLUIDO') {
		return <NewConcludedView notificacao={{ ...notificacao, status }} />;
	}

	return (
		<div className='w-[90%] sm:w-[95%] max-w-[1136px] mx-auto flex flex-col gap-4'>
			<div className='bg-[#F0F4F8] flex rounded-sm w-full content-center min-h-[142px] p-[32px] gap-[40px] justify-between lg:flex-row flex-col'>
				<div className='content-center items-center mx-auto'>
					<img
						className='w-[200px] sm:w-[300px] h-auto'
						src={logo}
						alt='logo'
					/>
				</div>
				<p className='text-[28px] sm:text-[32px] font-bold text-[#13335A] content-center max-w-[714px] text-center'>
					NOTIFICAÇÃO DE INCIDENTES E NÃO CONFORMIDADES
				</p>
			</div>
			<NewNotificacaoPreenchido notificacao={notificacao} viewOnly />
			{['CLASSIFICADO', 'INVESTIGADO'].includes(status) && (
				<NewClassificacaoPreenchido notificacao={notificacao} />
			)}
			{status === 'INVESTIGADO' && (
				<NewInvestigacaoPreenchido
					notificacao={notificacao}
					viewOnly
				/>
			)}
			<ReadOnlyPdfButton notificacao={notificacao} status={status} />
		</div>
	);
};

function NotesAvaliation() {
	const navigate = useNavigate();
	const [notes, setNotes] = useState([]);
	const [filtrosOpen, setFiltrosOpen] = useState(false);
	const filtrosRef = useRef(null);
	const [filters, setFilters] = useState([]);
	const [excelToken, setExcelToken] = useState('');
	const [currentId, setCurrentUnitId] = useState('');
	const [allNotes, setAllNotes] = useState([]);
	const [currentFilter, setCurrentFilter] = useState([]);
	const [invFilter, setInvFilter] = useState(false);
	const [protocolFilter, setProtocolFilter] = useState('');
	const [duality, setDuality] = useState(false);
	const [loading, setLoading] = useState(true);
	const [unitList, setUnitList] = useState(false);
	const [listUnits, setListUnits] = useState([]);
	const [listLoading, setListLoading] = useState(false);
	const [choseStatus, setChoseStatus] = useState(false);
	const [userPermissions, setUserPermissions] = useState([]);
	const [propNotes, setPropNotes] = useState([]);
	const [propCard, setPropCard] = useState({});
	const [notifyNumbers, setNotifyNumbers] = useState();
	const [excelAlert, setExcelAlert] = useState(false);
	const [invChanger, setInvChanger] = useState('');
	const [invList, setInvList] = useState([]);
	const [atribuidos, setAtribuidos] = useState([]);
	const [atribuidosList, setAtribuidosList] = useState([]);
	const [selectedInv, setSelectedInv] = useState('');
	const [carregando, setCarregando] = useState(false);
	const [dataInicio, setDataInicio] = useState('');
	const [dataFinal, setDataFinal] = useState('');
	const [notesNoPrazo, setNotesNoPrazo] = useState();
	const [selectedDelet, setSelectedDelet] = useState('');
	const [pendentes, setPendentes] = useState(undefined);
	const [motivoDelet, setMotivoDelet] = useState('');
	// Novos estados para filtros temporários (antes de aplicar)
	const [tempFilters, setTempFilters] = useState({
		atrasadas: false,
		concluidas: false,
		plano_acao: false,
		prazo: false,
		pendentes: false,
		rejeitadas: false,
		minhasInvestigacoes: false,
		dataInicio: '',
		dataFim: '',
	});

	// Filtros aplicados (após clicar em "Aplicar Filtros")
	const [appliedFilters, setAppliedFilters] = useState({
		atrasadas: false,
		concluidas: false,
		prazo: false,
		pendentes: false,
		rejeitadas: false,
		minhasInvestigacoes: false,
		dataInicio: '',
		dataFim: '',
	});

	const [changesDone, setChangesDone] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState([]);

	const [initialDate, setInitialDate] = useState('');
	const [finalDate, setFinalDate] = useState('');

	const [currentUser, setCurrentUser] = useState({
		unit: '',
		status: '',
		card: 'NOTIFICADO',
	});
	const [icons, setIcons] = useState({
		0: {
			icon: Relogio,
			status: 'notificados',
			descrição: 'Aguardando Classificação',
			noPrazo: '33',
			atrasados: '25',
		},
		1: {
			icon: Lupa,
			status: 'classificados',
			descrição: 'Em Investigação',
			noPrazo: '20',
			atrasados: '25',
		},
		2: {
			icon: Prancheta,
			status: 'investigados',
			descrição: 'Aguardando Avaliação',
			noPrazo: '12',
			atrasados: '7',
		},
		3: {
			icon: Check,
			status: 'concluidos',
			descrição: 'Notificações Concluídas',
			concluidos: '12',
		},
	});
	const [filter, setFilter] = useState('');
	const [isOpen, setIsOpen] = useState(false);
	const [showAlert, setShowAlert] = useState(true);
	const [selectedUnit, setSelectedUnit] = useState('');
	const [unitSearchTerm, setUnitSearchTerm] = useState('');
	const [showUnitSuggestions, setShowUnitSuggestions] = useState(false);

	const permissionStatusMap = {
		Classificadores: 'NOTIFICADO',
		Investigadores: 'CLASSIFICADO',
		Gestores: '',
	};

	const statusPermissionMap = {
		NOTIFICADO: 'Classificadores',
		CLASSIFICADO: 'Investigadores',
		'': 'Gestores',
	};

	const getNoteInvestigadores = (note = {}) => {
		const fromNote = Array.isArray(note?.investigadores)
			? note.investigadores
			: [];
		const fromAtribuidos =
			atribuidosList.find((item) => item?.protocolo === note?.protocolo)
				?.investigadores || [];

		return [...fromNote, ...fromAtribuidos].filter(
			(investigator) => investigator?.ativo !== false,
		);
	};

	const isCurrentUserAssignedToNote = (note = {}) => {
		const user = getUserCookie();
		return getNoteInvestigadores(note).some((investigator) =>
			sameInvestigator(investigator, user),
		);
	};

	const canCurrentUserInvestigateNote = (card, note = {}) => {
		const user = getUserCookie();
		return (
			hasGestorAndInvestigadorPermissions(user) &&
			card === 'CLASSIFICADO' &&
			workflowStatus(note?.status) === 'CLASSIFICADO' &&
			isCurrentUserAssignedToNote(note)
		);
	};

	const shouldOpenReadOnly = (caso, card, note = {}) => {
		const user = getUserCookie();
		if (isSubhueReadOnlyUser(user)) return true;

		if (
			hasGestorAndInvestigadorPermissions(user) &&
			!hasPermission(user, 'Classificadores') &&
			caso === 'CLASSIFICADO'
		) {
			return !canCurrentUserInvestigateNote(card, note);
		}

		if (
			card === 'CLASSIFICADO' &&
			workflowStatus(note?.status) === 'CLASSIFICADO' &&
			!isCurrentUserAssignedToNote(note) &&
			user?.cargo !== 'desenvolvedor'
		) {
			return true;
		}

		return false;
	};

	const getActionLabel = (caso, card, note = {}) => {
		const user = getUserCookie();
		if (isSubhueReadOnlyUser(user)) return 'Visualizar';
		if (shouldOpenReadOnly(caso, card, note)) return 'Visualizar';
		if (canCurrentUserInvestigateNote(card, note)) return 'Investigar';

		const key = `${caso}-${card}`;

		if (key === 'NOTIFICADO-INVESTIGADO' && note?.status === 'CONCLUIDO') {
			return 'Visualizar';
		}

		if (
			(user?.unidade?.includes('subhue') ||
				user?.unidade === 'sms' ||
				user?.cargo === 'sms' ||
				hasGestorOnlyFlowPermission(user) ||
				user?.cargo === 'usuario') &&
			currentUser.status === ''
		) {
			return 'Visualizar';
		}

		return (
			{
				'NOTIFICADO-CLASSIFICADO': 'Visualizar',
				'CLASSIFICADO-CLASSIFICADO': 'Investigar',
				'NOTIFICADO-NOTIFICADO': 'Classificar',
				'NOTIFICADO-INVESTIGADO': 'Avaliar',
				'CLASSIFICADO-NOTIFICADO': 'Visualizar',
				'CLASSIFICADO-INVESTIGADO': 'Visualizar',
				'CLASSIFICADO-CONCLUIDO': 'Visualizar',
				'NOTIFICADO-CONCLUIDO': 'Visualizar',
				'INVESTIGADO-NOTIFICADO': 'Visualizar',
				'INVESTIGADO-CLASSIFICADO': 'Visualizar',
			}[key] || null
		);
	};

	const getActionIcon = (caso, card, note = {}) => {
		const label = getActionLabel(caso, card, note);
		if (label === 'Visualizar') return <IoMdEye className='scale-[130%]' />;
		if (label === 'Investigar')
			return <FaSearch className='scale-[120%]' />;
		if (label === 'Classificar') {
			return <HiOutlinePencilSquare className='scale-[180%]' />;
		}
		if (label === 'Avaliar') {
			return <LuClipboardCheck className='scale-[180%]' />;
		}

		return null;
	};

	const getReadOnlyCaso = (card) =>
		card === 'INVESTIGADO' ? 'CLASSIFICADO' : 'VISUALIZAR';

	const handleDates = (event) => {
		setExcelAlert(false);
		const { value, id } = event.target;
		if (id === 'initialDate') {
			setInitialDate(value);
		} else {
			setFinalDate(value);
		}
	};

	const handleAddInv = async (username) => {
		const token = JSON?.parse(Cookies.get('user'))?.token;
		const result = await requestAtribuirInv(token, invChanger, username);
		if (result) {
			handleListInvestigators(invChanger);
			setSelectedInv('');
		}
	};

	const handleRemoveInv = async (username) => {
		setSelectedInv('');
		const token = JSON?.parse(Cookies.get('user'))?.token;
		const result = await requestDesativarInv(token, invChanger, username);
		if (result) {
			handleListInvestigators(invChanger);
		}
	};

	const handleClick = async (data) => {
		const obj = {
			classificados: 'CLASSIFICADO',
			investigados: 'INVESTIGADO',
			notificados: 'NOTIFICADO',
			concluidos: 'CONCLUIDO',
		};

		// 🔧 MUDANÇA: Preservar todos os dados do currentUser ao salvar
		handleSaveCache({
			unit: currentUser.unit,
			status: currentUser.status,
			card: obj[data] || 'NOTIFICADO',
			id:
				currentId ||
				(Cookies.get('cache')
					? JSON.parse(Cookies.get('cache')).id
					: ''), // 🔧 Preservar ID
		});

		const token = JSON.parse(Cookies.get('user')).token;
		let filter;
		if (allNotes.length > 0) {
			filter = allNotes.filter(
				(note) =>
					note?.unidade_nome === currentUser.unit &&
					note?.status === currentUser.card,
			);
		}
		const marcos = await requestAllInvestigations(token);

		let investigações = [];

		if (!marcos.error) {
			investigações = marcos?.filter(
				(marco) => marco?.unidade_nome === currentUser.unit,
			);
		}

		const paulo = await requestAllInvestigations(token, 'REINVESTIGACAO');
		let rein;

		if (!paulo.error) {
			rein = paulo?.filter(
				(note) => note.unidade_nome === currentUser.unit,
			);
		} else {
			rein = [];
		}
		/* async function carregarAtribuidosPorProtocolo(token, lista) {
			console.log(lista);
			const resultado = await Promise.all(
				lista.map(async (item) => {
					const atribuidos = await requestAtribuidos(
						token,
						item.protocolo
					);

					return {
						...item,
						atribuidos: atribuidos || [],
					};
				})
			);
			return resultado;
		} */

		switch (data) {
			case 'notificados':
				setListLoading(true);
				setNotes(
					allNotes?.filter(
						(note) =>
							note.unidade_nome === currentUser.unit &&
							note.status === 'NOTIFICADO',
					),
				);
				setItemsPerPage(
					allNotes?.filter(
						(note) =>
							note.unidade_nome === currentUser.unit &&
							note.status === 'NOTIFICADO',
					).length > 10
						? allNotes
								?.filter(
									(note) =>
										note.unidade_nome ===
											currentUser.unit &&
										note.status === 'NOTIFICADO',
								)
								.slice(0, 10)
						: allNotes?.filter(
								(note) =>
									note.unidade_nome === currentUser.unit &&
									note.status === 'NOTIFICADO',
							),
				);

				setCurrentUser({ ...currentUser, card: 'NOTIFICADO' });
				setCurrentFilter([]);
				setTimeout(() => {
					setListLoading(false);
				}, 1000);

				break;

			case 'classificados':
				setListLoading(true);
				setNotes([...investigações, ...rein]);
				setItemsPerPage(
					[...investigações, ...rein].length > 10
						? [...investigações, ...rein].slice(0, 10)
						: [...investigações, ...rein],
				);
				setCurrentUser({ ...currentUser, card: 'CLASSIFICADO' });
				setCurrentFilter([]);
				setTimeout(() => {
					setListLoading(false);
				}, 1000);

				break;
			case 'investigados':
				setListLoading(true);

				const filteredNotes =
					allNotes
						?.filter(
							(note) =>
								note.unidade_nome === currentUser.unit &&
								note.status === 'INVESTIGADO',
						)
						.sort((a, b) => {
							if (a.status === b.status) return 0;
							return a.status === 'INVESTIGADO' ? -1 : 1;
						}) || [];

				setNotes(filteredNotes);

				setItemsPerPage(
					filteredNotes.length > 10
						? filteredNotes.slice(0, 10)
						: filteredNotes,
				);

				setCurrentUser({ ...currentUser, card: 'INVESTIGADO' });
				setCurrentFilter([]);

				setTimeout(() => {
					setListLoading(false);
				}, 1000);

				break;

			case 'concluidos':
				setListLoading(true);
				setNotes(
					allNotes?.filter(
						(note) =>
							note.unidade_nome === currentUser.unit &&
							note.status === 'CONCLUIDO',
					),
				);
				setItemsPerPage(
					allNotes?.filter(
						(note) =>
							note.unidade_nome === currentUser.unit &&
							note.status === 'CONCLUIDO',
					).length > 10
						? allNotes
								?.filter(
									(note) =>
										note.unidade_nome ===
											currentUser.unit &&
										note.status === 'CONCLUIDO',
								)
								.slice(0, 10)
						: allNotes?.filter(
								(note) =>
									note.unidade_nome === currentUser.unit &&
									note.status === 'CONCLUIDO',
							),
				);

				setCurrentUser({ ...currentUser, card: 'CONCLUIDO' });
				setCurrentFilter([]);
				setTimeout(() => {
					setListLoading(false);
				}, 1000);

				break;

			default:
				console.log('Valor não corresponde a nenhum caso');
		}
	};

	const handleSendInvChanges = () => {
		setChangesDone(true);
		setSelectedInv('');
	};

	const handleFilters = (event) => {
		const { id, checked } = event.target;

		setTempFilters((prev) => {
			// Se marcar "atrasadas", desmarca "prazo"
			if (id === 'atrasadas') {
				return {
					...prev,
					atrasadas: checked,
					prazo: false,
				};
			}

			// Se marcar "prazo", desmarca "atrasadas"
			if (id === 'prazo') {
				return {
					...prev,
					prazo: checked,
					atrasadas: false,
				};
			}

			// Filtro independente
			if (id === 'rejeitadas') {
				return {
					...prev,
					rejeitadas: checked,
				};
			}

			// Filtro pendentes do plano de acao
			if (id === 'plano_acao') {
				return {
					...prev,
					plano_acao: checked,
				};
			}

			// fallback genérico (caso existam outros filtros)
			return {
				...prev,
				[id]: checked,
			};
		});
	};

	const handleApplyFilters = async () => {
		setListLoading(true);
		const token = JSON.parse(Cookies.get('user')).token;
		const userName = JSON.parse(Cookies.get('user')).userName;

		let filteredNotes = [...notes];

		// 1. Filtro de DATA
		if (tempFilters.dataInicio || tempFilters.dataFim) {
			filteredNotes = filteredNotes.filter((note) => {
				const dataOcorrencia =
					note?.data_ocorrencia || note?.notificacao?.data_ocorrencia;
				if (!dataOcorrencia) return false;

				const dataNote = new Date(dataOcorrencia);
				const inicio = tempFilters.dataInicio
					? new Date(tempFilters.dataInicio)
					: null;
				const fim = tempFilters.dataFim
					? new Date(tempFilters.dataFim)
					: null;

				if (inicio && fim) {
					return dataNote >= inicio && dataNote <= fim;
				} else if (inicio) {
					return dataNote >= inicio;
				} else if (fim) {
					return dataNote <= fim;
				}
				return true;
			});
		}

		// 3. Filtro ATRASADAS / NO PRAZO
		if (currentUser.card === 'CLASSIFICADO') {
			if (tempFilters.atrasadas === true) {
				filteredNotes = filteredNotes.filter(
					(item) =>
						!notesNoPrazo?.classificados?.some(
							(n) => n.protocolo === item.protocolo,
						),
				);
			} else if (tempFilters.prazo === true) {
				filteredNotes = filteredNotes.filter((item) =>
					notesNoPrazo?.classificados?.some(
						(n) => n.protocolo === item.protocolo,
					),
				);
			}
		}

		if (currentUser.card === 'INVESTIGADO') {
			if (tempFilters.atrasadas === true) {
				filteredNotes = filteredNotes.filter(
					(item) =>
						!notesNoPrazo?.investigados?.some(
							(n) => n.protocolo === item.protocolo,
						),
				);
			} else if (tempFilters.prazo === true) {
				filteredNotes = filteredNotes.filter((item) =>
					notesNoPrazo?.investigados?.some(
						(n) => n.protocolo === item.protocolo,
					),
				);
			}
		}

		if (currentUser.card === 'NOTIFICADO') {
			if (tempFilters.atrasadas === true) {
				filteredNotes = filteredNotes.filter(
					(item) =>
						!notesNoPrazo?.notificados?.some(
							(n) => n.protocolo === item.protocolo,
						),
				);
			} else if (tempFilters.prazo === true) {
				filteredNotes = filteredNotes.filter((item) =>
					notesNoPrazo?.notificados?.some(
						(n) => n.protocolo === item.protocolo,
					),
				);
			}
		}

		// 5. Filtro REJEITADAS
		if (tempFilters.rejeitadas && currentUser.card === 'CONCLUIDO') {
			const result = await requestClassDiscard(
				token,
				currentId?.replace(/-/g, '').split('').reverse().join(''),
			);
			const resultado = filteredNotes.filter((a) =>
				result.some((b) => b.protocolo === a.protocolo),
			);
			filteredNotes = resultado;
		}

		// 5. Filtro pedentes do plano de acao
		if (tempFilters?.plano_acao && currentUser?.card === 'CONCLUIDO') {
			const resultado = filteredNotes.filter((a) =>
				pendentes?.resultados.some(
					(b) => b?.notificacao === a?.protocolo,
				),
			);
			filteredNotes = resultado;
		}

		// Aplicar os filtros
		setAppliedFilters(tempFilters);
		setCurrentFilter(
			filteredNotes.length > 0
				? filteredNotes
				: 'Nenhuma notificação encontrada',
		);
		setItemsPerPage(
			filteredNotes.length > 10
				? filteredNotes.slice(0, 10)
				: filteredNotes,
		);
		setCurrentPage(1);

		setTimeout(() => {
			setListLoading(false);
		}, 500);
	};

	const handleClearFilters = () => {
		// Limpar estados temporários
		setTempFilters({
			atrasadas: false,
			concluidos: false,
			pendentes: false,
			minhasInvestigacoes: false,
			dataInicio: '',
			dataFim: '',
		});

		// Limpar estados aplicados
		setAppliedFilters({
			atrasadas: false,
			concluidos: false,
			pendentes: false,
			minhasInvestigacoes: false,
			dataInicio: '',
			dataFim: '',
		});

		// Resetar para lista original
		setCurrentFilter([]);
		setItemsPerPage(notes.length > 10 ? notes.slice(0, 10) : notes);
		setCurrentPage(1);
	};

	const conteudo = 'Pendente';

	const meses = [
		'janeiro',
		'fevereiro',
		'março',
		'abril',
		'maio',
		'junho',
		'julho',
		'agosto',
		'setembro',
		'outubro',
		'novembro',
		'dezembro',
	];

	const handlePaginate = (event) => {
		const { id } = event?.target;
		let totalItems;

		currentFilter.length > 0 &&
		currentFilter !== 'Nenhuma notificação encontrada'
			? (totalItems = currentFilter)
			: (totalItems = notes);

		const pageSize = 10;
		const totalParts = Math.ceil(totalItems.length / pageSize);

		const parts = [];
		for (let i = 0; i < totalParts; i++) {
			parts.push(totalItems.slice(i * pageSize, (i + 1) * pageSize));
		}

		const pageIndex = parseInt(id, 10) - 1;
		const result = parts[pageIndex] || [];

		setItemsPerPage(result);
		setCurrentPage(parseInt(id, 10));
	};

	const handleInvNotesFilter = async () => {
		setInvFilter(true);
		const token = JSON.parse(Cookies.get('user')).token;
		const userName = JSON.parse(Cookies.get('user')).userName;
		let result = await requestNotesByInv(token, userName);

		if (!result.detail) {
			let toma = result?.filter(
				(note) =>
					note.status !== 'CONCLUIDO' && note.status !== 'NOTIFICADO',
			);

			setCurrentFilter(toma);
		} else {
			setCurrentFilter([]);
		}
	};

	const handleAvalNotesFilter = async (param) => {
		let aux = notes;

		if (param === 'CONCLUIDO') {
			aux = notes.filter((item) => {
				return item.status === 'CONCLUIDO';
			});
			aux.length > 0
				? setCurrentFilter(aux)
				: setCurrentFilter('Nenhuma notificação encontrada');
		} else {
			aux = notes.filter((item) => {
				return item.status === 'INVESTIGADO';
			});
			aux.length > 0
				? setCurrentFilter(aux)
				: setCurrentFilter('Nenhuma notificação encontrada');
		}
	};

	const userCookie = Cookies.get('user')
		? JSON.parse(Cookies.get('user'))
		: null;
	const availablePermissions = [
		'Investigadores',
		'Classificadores',
		'Gestores',
	].filter((permission) => hasPermission(userCookie, permission));
	const hasGestorPermission = hasPermission(userCookie, 'Gestores');
	const hasInvestigadorPermission = hasPermission(
		userCookie,
		'Investigadores',
	);
	const hasClassificadorPermission = hasPermission(
		userCookie,
		'Classificadores',
	);
	const isSubhueReadOnly = isSubhueReadOnlyUser(userCookie);
	const hasSpecialProfile =
		userCookie?.cargo === 'desenvolvedor' ||
		(isSubhueUser(userCookie) && !isSubhueReadOnly) ||
		userCookie?.unidade === 'sms' ||
		userCookie?.cargo === 'sms';
	const orderedPermissions = [
		hasClassificadorPermission ? 'Classificadores' : null,
		hasInvestigadorPermission ? 'Investigadores' : null,
		!hasClassificadorPermission &&
		!hasInvestigadorPermission &&
		hasGestorPermission
			? 'Gestores'
			: null,
	].filter(Boolean);
	const shouldShowProfileSelect =
		!isSubhueReadOnly &&
		(orderedPermissions.length > 1 || hasSpecialProfile);
	const selectedPermission = orderedPermissions.includes(
		statusPermissionMap[currentUser.status],
	)
		? statusPermissionMap[currentUser.status]
		: orderedPermissions[0] || '';
	const permissionDisplayMap = {
		Classificadores: 'classificador',
		Investigadores: 'investigador',
		Gestores: 'gestor',
	};
	const canShowUnitFilter =
		Boolean(userCookie) &&
		(isSubhueUser(userCookie) ||
			userCookie?.unidade === 'sms' ||
			userCookie?.cargo === 'sms' ||
			userCookie?.cargo === 'desenvolvedor') &&
		userCookie?.cargo !== 'gestor';
	const hasGestorLayout = hasGestorPermission && !canShowUnitFilter;
	const canShowExportFilter =
		Boolean(userCookie) &&
		(userCookie?.cargo === 'desenvolvedor' ||
			isSubhueUser(userCookie) ||
			userCookie?.cargo === 'gestor' ||
			userCookie?.unidade === 'sms' ||
			userCookie?.cargo === 'sms');
	const canShowHeaderFilters =
		Boolean(userCookie) &&
		(isSubhueUser(userCookie) ||
			userCookie?.unidade === 'sms' ||
			userCookie?.cargo === 'sms' ||
			userCookie?.cargo === 'gestor' ||
			hasGestorPermission ||
			orderedPermissions.length > 1);
	const exportTitle = selectedUnit
		? 'Exportar documento'
		: 'Exportar Consolidado das unidades';
	const filteredUnits = listUnits.filter((unit) =>
		String(unit?.nome || '')
			.toLowerCase()
			.includes(String(unitSearchTerm || '').toLowerCase()),
	);

	const handleExcelExport = async () => {
		const diffDays =
			(new Date(finalDate) - new Date(initialDate)) / 86400000;

		if (
			diffDays >= 183 ||
			diffDays <= -183 ||
			new Date(finalDate) < new Date(initialDate)
		) {
			setExcelAlert(true);
		} else {
			const user = JSON.parse(Cookies.get('user'));
			const user_token = user.token;
			const unit_token = selectedUnit ? currentId || excelToken : '';

			let currentToken = '';

			if (unit_token !== undefined) {
				currentToken = unit_token
					.replace(/-/g, '')
					.split('')
					.reverse()
					.join('');
			} else {
				if (excelToken?.includes('-')) {
					currentToken = excelToken
						?.replace(/-/g, '')
						?.split('')
						?.reverse()
						?.join('');
				} else {
					currentToken = excelToken;
				}
			}

			const response = await requestExcelExport(
				user_token,
				currentToken === 'todas' ? '' : currentToken,
				initialDate,
				finalDate,
			);

			if (!response.error) {
				const blob = response.blob;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = `consolidado-notificações-${
					selectedUnit || 'todas-unidades'
				}.xlsx`;

				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);

				window.URL.revokeObjectURL(url);
			} else {
				console.error(response.error);
			}
		}
	};

	const SEARCH_FIELDS = [
		'protocolo',
		'unidade_nome',
		'tipo_incidente_display',
		'nome_paciente',
		'setor',
	];

	const normalizeText = (value) =>
		(value ?? '').toString().toLowerCase().replace(/-/g, '').trim();

	const handleSearchProtocol = (search) => {
		setListLoading(true);
		const normalizedSearch = normalizeText(search);

		// Se o campo estiver vazio, reseta
		if (!normalizedSearch) {
			setCurrentFilter(notes);
			setItemsPerPage(notes.slice(0, 10));
			setListLoading(false);
			return;
		}

		const result = notes.filter((note) => {
			const isSpecialStatus =
				note?.status === 'REINVESTIGACAO' ||
				note?.status === 'CLASSIFICADO';

			return SEARCH_FIELDS.some((field) => {
				// Caso especial: protocolo sempre vem direto em note
				if (field === 'protocolo') {
					return normalizeText(note?.protocolo).includes(
						normalizedSearch,
					);
				}

				// Caso REINVESTIGACAO ou CLASSIFICADO → busca dentro de notificacao
				if (isSpecialStatus) {
					return normalizeText(note?.notificacao?.[field]).includes(
						normalizedSearch,
					);
				}

				// Caso padrão
				return normalizeText(note?.[field]).includes(normalizedSearch);
			});
		});

		// mock de loading
		setTimeout(() => {
			setCurrentFilter(result);
			setItemsPerPage(result.slice(0, 10));
			setListLoading(false);
		}, 500);
	};

	const ListUnits = async () => {
		const result = await requestNewUnits();
		if (!result.error) {
			setListUnits(result);
		}
	};

	const toggleAccordion = async () => {
		setIsOpen(!isOpen);
	};

	const filteChange = (e) => {
		setFilter(e.target.id);

		let result = notes.sort((a, b) =>
			a[e.target.id] > b[e.target.id] ? 1 : -1,
		);

		if (filter === e.target.id) {
			result = notes.sort((a, b) =>
				a[e.target.id] < b[e.target.id] ? 1 : -1,
			);

			setCurrentFilter(result);
		} else {
			setCurrentFilter(result);
		}
	};

	const getIncidentDisplay = (notificacao = {}) => {
		const tipoDisplay =
			notificacao?.tipo_incidente_display ||
			notificacao?.notificacao?.tipo_incidente_display;
		const tipo =
			notificacao?.tipo_incidente ||
			notificacao?.notificacao?.tipo_incidente;

		if (tipoDisplay?.trim()) return tipoDisplay.trim();
		if (tipo === 'OUTROS') return 'Outros';
		if (!tipo?.trim()) return 'Não consta';

		return tipo.trim();
	};

	const goToClassification = (caso, card, note) => {
		if (shouldOpenReadOnly(caso, card, note)) {
			setPropNotes(note);
			setPropCard({ caso: getReadOnlyCaso(card), card, viewOnly: true });
			setLoading(true);
			setDuality(!duality);
			setTimeout(() => {
				setLoading(false);
			}, 2000);
			return;
		}

		const user = getUserCookie();
		if (
			caso === 'CLASSIFICADO' &&
			card === 'CLASSIFICADO' &&
			(user?.unidade === 'sms' || user?.cargo === 'sms') &&
			user?.cargo !== 'desenvolvedor'
		) {
			setPropNotes(note);
			setPropCard({ caso: 'NOTIFICADO', card: 'CLASSIFICADO' });
			setLoading(true);
			setDuality(!duality);
			setTimeout(() => {
				setLoading(false);
			}, 2000);
		} else {
			if (caso === card) {
				setPropNotes(note);
				setPropCard({ caso, card });
				setLoading(true);
				setDuality(!duality);
				setTimeout(() => {
					setLoading(false);
				}, 2000);
			}
			if (caso !== card) {
				setPropNotes(note);
				setPropCard({ caso, card });
				setLoading(true);
				setDuality(!duality);
				setTimeout(() => {
					setLoading(false);
				}, 2000);
			}
		}
	};

	const categorySelect = (permission) => {
		// 🔧 MUDANÇA: Preservar unit e id do currentUser
		if (permission === 'Classificadores') {
			setCurrentUser((prev) => ({
				...prev,
				status: 'NOTIFICADO',
			}));
			handleSaveCache({
				...currentUser,
				status: 'NOTIFICADO',
				unit: currentUser.unit, // 🔧 Preservar unidade
				id:
					currentId ||
					(Cookies.get('cache')
						? JSON.parse(Cookies.get('cache')).id
						: ''), // 🔧 Preservar ID
			});
			setInvFilter(false);
			setChoseStatus(true);
		} else if (permission === 'Investigadores') {
			setCurrentUser((prev) => ({
				...prev,
				status: 'CLASSIFICADO',
			}));
			handleSaveCache({
				...currentUser,
				status: 'CLASSIFICADO',
				unit: currentUser.unit, // 🔧 Preservar unidade
				id:
					currentId ||
					(Cookies.get('cache')
						? JSON.parse(Cookies.get('cache')).id
						: ''), // 🔧 Preservar ID
			});
			setInvFilter(false);
			setChoseStatus(true);
		} else if (permission === 'Gestores') {
			setCurrentUser((prev) => ({
				...prev,
				status: '',
			}));
			handleSaveCache({
				...currentUser,
				status: '',
				unit: currentUser.unit,
				id:
					currentId ||
					(Cookies.get('cache')
						? JSON.parse(Cookies.get('cache')).id
						: ''),
			});
			setInvFilter(false);
			setChoseStatus(true);
		}
	};

	const handleListInvestigators = async (protocolo) => {
		setCarregando(true);
		setChangesDone(false);
		setAtribuidos([]);
		let userCookie = JSON.parse(Cookies.get('user'));

		const atribuidos = await requestAtribuidos(userCookie.token, protocolo);
		const avaiableInvs = await requestInvestigators(
			userCookie.token,
			protocolo,
		);

		setTimeout(() => {
			setAtribuidos(atribuidos);
			setInvList(avaiableInvs);
			setCarregando(false);
		}, [400]);
	};

	const handleRequest = async (developerUnit, token) => {
		if (!developerUnit && !token) {
			console.log('Aguardando seleção de unidade...');
			setNotifyNumbers({
				notificados: [],
				classificados: [],
				investigados: [],
				concluidos: [],
			});
			setLoading(false);
			return;
		}

		setLoading(true);

		let userCookie = JSON.parse(Cookies.get('user'));

		const requestPendentes = await requestPAResume(
			userCookie.token,
			token?.replace(/-/g, '').split('').reverse().join(''),
		);
		setPendentes(requestPendentes);

		const requestNoPrazo = await requestListNotes(
			userCookie.token,
			token?.replace(/-/g, '').split('').reverse().join(''),
			false,
		);
		const result = await requestListNotes(
			userCookie.token,
			token?.replace(/-/g, '').split('').reverse().join(''),
		);
		let unit = userCookie.unidade;

		if (
			JSON?.parse(Cookies.get('user'))?.cargo === 'desenvolvedor' ||
			JSON?.parse(Cookies.get('user'))?.unidade === 'subhue' ||
			JSON?.parse(Cookies.get('user'))?.unidade === 'sms' ||
			JSON?.parse(Cookies.get('user'))?.cargo === 'gestor' ||
			JSON?.parse(Cookies.get('user'))
				.permissao.filter((p) =>
					['Investigadores', 'Classificadores', 'Gestores'].includes(
						p,
					),
				)
				.includes('Gestores') ||
			JSON.parse(Cookies.get('user'))
				.permissao.filter((p) =>
					['Investigadores', 'Classificadores', 'Gestores'].includes(
						p,
					),
				)
				.includes('Investigadores')
		) {
			unit = developerUnit;
		}

		const marcosResponse = await requestAllInvestigations(
			userCookie?.token,
		);
		const marcos = Array.isArray(marcosResponse) ? marcosResponse : [];

		const pauloResponse = await requestAllInvestigations(
			userCookie?.token,
			'REINVESTIGACAO',
		);
		const paulo = Array.isArray(pauloResponse) ? pauloResponse : [];

		let rein = [];
		if (paulo.length > 0 && unit) {
			rein = paulo.filter((note) => note?.unidade_nome === unit);
		}

		let investigações = [];

		if (marcos?.length > 0) {
			if (token) {
				investigações = marcos?.filter(
					(marco) => marco?.unidade_id === token,
				);
			} else if (userCookie?.id) {
				investigações = marcos?.filter(
					(marco) => marco?.unidade_id === userCookie.id,
				);
			} else if (Cookies.get('cache')) {
				if (JSON.parse(Cookies.get('cache'))?.unit) {
					investigações = marcos?.filter(
						(marco) =>
							marco?.unidade_nome ===
							JSON.parse(Cookies.get('cache'))?.unit,
					);
				}
			}
		}

		function agruparNotificacoesPorStatus(notificacoes) {
			if (!Array.isArray(notificacoes)) {
				console.error('notificacoes não é um array:', notificacoes);
				return {
					notificados: [],
					classificados: [],
					investigados: [],
					concluidos: [],
				};
			}

			const notificacoesFiltradas = notificacoes.filter(
				(n) => n?.unidade_nome === unit,
			);
			return {
				notificados: notificacoesFiltradas.filter(
					(n) => n.status === 'NOTIFICADO',
				),
				classificados: [...investigações, ...rein],
				investigados: notificacoesFiltradas.filter(
					(n) => n.status === 'INVESTIGADO',
				),
				concluidos: notificacoesFiltradas.filter(
					(n) => n.status === 'CONCLUIDO',
				),
			};
		}

		const agruparPorStatus = (notificacoes = []) => {
			const resultado = {
				notificados: [],
				classificados: [],
				investigados: [],
				concluidos: [],
			};
			notificacoes.forEach((item) => {
				const status = (item?.status || '').toUpperCase();

				switch (status) {
					case 'NOTIFICADO':
						resultado?.notificados.push(item);
						break;

					case 'CLASSIFICADO':
					case 'REINVESTIGACAO':
						resultado.classificados.push(item);
						break;

					case 'INVESTIGADO':
						resultado.investigados.push(item);
						break;

					case 'CONCLUIDO':
						resultado.concluidos.push(item);
						break;

					default:
				}
			});

			return resultado;
		};

		setNotifyNumbers(agruparNotificacoesPorStatus(result));
		setNotesNoPrazo(agruparPorStatus(requestNoPrazo));

		const cache = new Map();

		async function carregarAtribuidosPorProtocolo(token, lista) {
			const resultado = await Promise.all(
				lista.map(async (item) => {
					if (cache.has(item.protocolo)) {
						return {
							...item,
							investigadores: cache.get(item.protocolo),
						};
					}

					const atribuidos = atribuidosList;
					cache.set(item.protocolo, atribuidos?.investigadores || []);

					return {
						...item,
						investigadores: atribuidos.investigadores || [],
					};
				}),
			);

			return resultado;
		}

		if (!result.error) {
			// 🔧 MUDANÇA: Usar currentUser.card ao invés de hardcoded 'NOTIFICADO'
			const cacheCookie = Cookies.get('cache')
				? JSON.parse(Cookies.get('cache'))
				: null;
			const cardToFilter = cacheCookie?.card || 'NOTIFICADO';

			let filter = result.filter(
				(note) =>
					note?.unidade_nome === unit &&
					(cardToFilter === 'CLASSIFICADO'
						? note?.status === 'CLASSIFICADO' ||
							note?.status === 'REINVESTIGACAO'
						: note?.status === cardToFilter),
			);

			setAllNotes(result);

			const baseList =
				cardToFilter === 'CLASSIFICADO'
					? [...investigações, ...rein]
					: filter;

			// 🔥 CHAMA UMA VEZ SÓ

			setAtribuidosList(
				[...investigações, ...rein].map((item) => ({
					protocolo: item.protocolo,
					investigadores: item.investigadores,
				})),
			);

			const notesComAtribuidos = await carregarAtribuidosPorProtocolo(
				userCookie.token,
				baseList,
			);

			// Reaproveita
			setNotes(notesComAtribuidos);

			setItemsPerPage(
				notesComAtribuidos.length > 10
					? notesComAtribuidos.slice(0, 10)
					: notesComAtribuidos,
			);

			setLoading(false);
		} else {
			console.log(result.error);
			setNotifyNumbers({
				notificados: [],
				classificados: [],
				investigados: [],
				concluidos: [],
			});
			setLoading(false);
		}
	};

	/* 	teste */

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				filtrosRef.current &&
				!filtrosRef.current.contains(event.target)
			) {
				setFiltrosOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	useEffect(() => {
		const userCookieRaw = Cookies.get('user');
		if (!userCookieRaw) return;
		const userCookie = JSON.parse(userCookieRaw);
		const cacheCookieRaw = Cookies.get('cache');
		const cacheCookie = cacheCookieRaw ? JSON.parse(cacheCookieRaw) : null;
		const initialAvailablePermissions = [
			'Investigadores',
			'Classificadores',
			'Gestores',
		].filter((permission) => hasPermission(userCookie, permission));
		const initialHasGestorPermission = initialAvailablePermissions.includes(
			'Gestores',
		);
		const initialHasInvestigadorPermission =
			initialAvailablePermissions.includes('Investigadores');
		const initialHasClassificadorPermission =
			initialAvailablePermissions.includes('Classificadores');
		const initialEffectivePermissions = [
			initialHasClassificadorPermission ? 'Classificadores' : null,
			initialHasInvestigadorPermission ? 'Investigadores' : null,
			!initialHasClassificadorPermission &&
			!initialHasInvestigadorPermission &&
			initialHasGestorPermission
				? 'Gestores'
				: null,
		].filter(Boolean);
		const cachedPermission = statusPermissionMap[cacheCookie?.status || ''];
		const initialStatusFallback =
			initialEffectivePermissions.length === 0
				? ''
				: initialEffectivePermissions[0] === 'Investigadores'
					? 'CLASSIFICADO'
					: initialEffectivePermissions[0] === 'Gestores'
						? ''
						: 'NOTIFICADO';

		// Token para Excel
		const tokenSource = cacheCookie?.id || userCookie?.id;
		setExcelToken(
			tokenSource?.replace(/-/g, '').split('').reverse().join(''),
		);

		// Lista de unidades visíveis
		if (
			isSubhueUser(userCookie) ||
			userCookie.unidade === 'sms' ||
			userCookie.cargo === 'sms'
		) {
			setUnitList(true);
		}

		ListUnits();

		const hasMultiplePermissions = initialEffectivePermissions.length > 1;
		setUserPermissions(initialEffectivePermissions);

		let initialUnit = '';
		let initialId = '';

		if (cacheCookie && cacheCookie.unit && cacheCookie.id) {
			initialUnit = cacheCookie.unit;
			initialId = cacheCookie.id;
			setSelectedUnit(initialUnit);
			setUnitSearchTerm(initialUnit);
			setCurrentUnitId(initialId); // 🔧 ADICIONAR: Setar o currentId
			setTimeout(() => {
				setSelectedUnit(initialUnit);
			}, 100);
		} else if (
			!isSubhueUser(userCookie) &&
			userCookie?.cargo !== 'desenvolvedor'
		) {
			initialUnit = userCookie?.unidade;
			initialId = userCookie?.id;
			setSelectedUnit(initialUnit);
			setUnitSearchTerm(initialUnit);
			setCurrentUnitId(initialId); // 🔧 ADICIONAR: Setar o currentId
		}

		setCurrentUser((prev) => ({
			...prev,
			unit: initialUnit,
			card: cacheCookie?.card || 'NOTIFICADO',
			status:
				cacheCookie?.status &&
				initialEffectivePermissions.includes(cachedPermission)
					? cacheCookie.status
					: initialStatusFallback,
		}));

		if (initialUnit && initialId) {
			handleRequest(initialUnit, initialId);
		} else {
			setLoading(false);
			setNotifyNumbers({
				notificados: [],
				classificados: [],
				investigados: [],
				concluidos: [],
			});
		}

		if (hasMultiplePermissions) {
			setChoseStatus(true);
		}

		if (
			['desenvolvedor', 'gestor', 'sms'].includes(userCookie.cargo) ||
			isSubhueUser(userCookie) ||
			userCookie.unidade === 'sms' ||
			userCookie.cargo === 'sms' ||
			hasPermission(userCookie, 'Classificadores') ||
			hasPermission(userCookie, 'Investigadores')
		) {
			setShowAlert(false);
		}

		if (isSubhueReadOnlyUser(userCookie)) {
			setCurrentUser((prev) => ({ ...prev, status: '' }));
		}
	}, []);

	const handleSelection = async (value, id) => {
		setNotifyNumbers(undefined);
		if (id === 'todos' || value === 'todos') {
			setExcelToken('');
			setSelectedUnit('');
			setUnitSearchTerm('Todas para download');
			setCurrentUnitId('');
			setNotes([]);
			setAllNotes([]);
			setItemsPerPage([]);
			setCurrentFilter([]);
			setCurrentPage(1);
			setListLoading(false);
			setLoading(false);
			setNotesNoPrazo({
				notificados: [],
				classificados: [],
				investigados: [],
				concluidos: [],
			});
			setPendentes({
				resumo: {
					total_concluidos_com_plano_pendente: 0,
				},
				resultados: [],
			});
			setNotifyNumbers({
				notificados: [],
				classificados: [],
				investigados: [],
				concluidos: [],
			});
			setCurrentUser((prev) => ({ ...prev, unit: '' }));
			handleSaveCache({
				...currentUser,
				unit: '',
				id: '',
				card: currentUser.card,
				status: currentUser.status,
			});
		} else {
			setCurrentUser({ ...currentUser, unit: value });
			setCurrentUnitId(id); // 🔧 Isso já existe
			setExcelToken(id === 'vazio' ? '' : id);
			setSelectedUnit(value);
			setUnitSearchTerm(value);
			handleRequest(value, id);
			handleSaveCache({
				...currentUser,
				unit: value,
				id: id, // 🔧 Garantir que o ID seja salvo
				card: currentUser.card, // 🔧 Preservar card
				status: currentUser.status, // 🔧 Preservar status
			});
		}
	};

	const handleUnitInputChange = (value) => {
		setUnitSearchTerm(value);
		setShowUnitSuggestions(true);

		const exactMatch = listUnits.find(
			(unit) =>
				String(unit?.nome || '').toLowerCase() ===
				String(value || '').toLowerCase(),
		);

		if (exactMatch) {
			handleSelection(exactMatch.nome, exactMatch.id);
			return;
		}

		setSelectedUnit('');
		setCurrentUnitId('');
		setExcelToken('');
		setCurrentUser((prev) => ({ ...prev, unit: '' }));
	};

	const handleUnitPick = (unit) => {
		setUnitSearchTerm(unit.nome);
		setShowUnitSuggestions(false);
		handleSelection(unit.nome, unit.id);
	};

	const selectRef = useRef(null);

	const handleSaveCache = (data) => {
		Cookies.set(
			'cache',
			JSON.stringify({
				unit: data?.unit,
				status: data?.status,
				card: data?.card || 'NOTIFICADO',
				id: data?.id || currentId, // 🔧 Incluir o ID
			}),
			{ expires: 1 },
		);
	};

	useEffect(() => {}, [currentId, selectedUnit, currentUser]);

	return (
		<div className='flex flex-col mx-auto min-h-screen'>
			<NavBar />
			{!duality && Cookies.get('user') && (
				<div className='sm:top-[80px] mt-[80px] bg-[#F0F4F8] w-full'>
					<div className='w-[90%] sm:w-[95%] mx-auto items-center max-w-[1136px]'>
						<div className='px-[32px] py-[36px] '>
							<p className='text-[20px] md:text-[32px] font-semibold w-full text-center text-[#004A80]'>
								Avaliação das notificações de incidentes
							</p>
						</div>
						<div className='w-[90%] sm:w-[100%] mx-auto items-center max-w-[1136px] flex'>
							<div className='flex flex-col '></div>
						</div>
					</div>
				</div>
			)}
			{!duality && canShowHeaderFilters ? (
				<div className='w-[90%] sm:w-[95%] mx-auto items-center max-w-[1136px] mt-3 rounded-xl border border-[#E3E3E3] bg-white shadow-[0_4px_14px_rgba(15,23,42,0.08)] px-3 sm:px-6 py-4 sm:py-6 font-inter'>
					<p className='text-[#173A67] font-semibold text-[18px] sm:text-[22px]'>
						Filtros
					</p>
					<div className='w-full h-[1px] bg-[#E5E7EB] my-4'></div>
					<div
						className={`flex flex-col lg:flex-row lg:items-end ${hasGestorLayout ? 'gap-4 lg:gap-6' : 'gap-3 lg:gap-0'}`}>
						{shouldShowProfileSelect && (
							<div className='w-full lg:max-w-[210px] items-end content-end'>
								<p className='text-[14px] font-medium text-[#173A67] mb-2'>
									Perfil
								</p>
								<select
									value={selectedPermission}
									onChange={(e) =>
										categorySelect(e.target.value)
									}
									className='border border-[#E3E3E3] rounded-lg px-3 py-2 w-full h-[40px] text-[14px] font-medium outline-none transition-colors bg-white text-[#4F5257]'>
									{orderedPermissions.map((permission) => (
										<option
											key={permission}
											value={permission}>
											{permission}
										</option>
									))}
								</select>
							</div>
						)}
						{!shouldShowProfileSelect && selectedPermission && (
							<div className='w-full lg:max-w-[210px] items-end content-end'>
								<p className='text-[14px] font-medium text-[#173A67] mb-2'>
									Perfil
								</p>
								<div className='border border-[#E3E3E3] rounded-lg px-3 py-2 w-full h-[40px] text-[14px] font-medium bg-[#F9FAFB] text-[#4F5257] flex items-center capitalize'>
									{permissionDisplayMap[selectedPermission] ||
										selectedPermission}
								</div>
							</div>
						)}

						{canShowUnitFilter && (
							<div
								className={`w-full items-end content-end ${
									isSubhueReadOnly
										? 'lg:flex-1 lg:max-w-none lg:pr-6'
										: 'lg:max-w-[360px] lg:px-4'
								}`}>
								<p className='text-[14px] font-medium text-[#173A67] mb-2'>
									Unidade
								</p>
								<div className='relative'>
									<input
										type='text'
										ref={selectRef}
										value={unitSearchTerm}
										onChange={(e) =>
											handleUnitInputChange(
												e.target.value,
											)
										}
										onFocus={() =>
											setShowUnitSuggestions(true)
										}
										onBlur={() =>
											setTimeout(
												() =>
													setShowUnitSuggestions(
														false,
													),
												120,
											)
										}
										placeholder='Selecione'
										className='border border-[#E3E3E3] rounded-lg px-3 py-2 w-full h-[40px] text-[14px] font-medium text-[#4F5257] outline-none'
									/>
									<button
										type='button'
										onMouseDown={(e) => {
											e.preventDefault();
											setShowUnitSuggestions(
												(prev) => !prev,
											);
										}}
										className='absolute right-3 top-1/2 -translate-y-1/2 text-[#6B7280]'>
										▾
									</button>
									{showUnitSuggestions && (
										<div className='absolute left-0 right-0 top-full mt-1 z-30 max-h-[220px] overflow-y-auto rounded-lg border border-[#E3E3E3] bg-white shadow-sm'>
											<button
												type='button'
												onMouseDown={(e) => {
													e.preventDefault();
													handleSelection(
														'todos',
														'todos',
													);
													setShowUnitSuggestions(
														false,
													);
												}}
												className='block w-full px-3 py-2 text-left text-[14px] text-[#4F5257] hover:bg-[#F3F4F6]'>
												Todas para download
											</button>
											{filteredUnits.length > 0 ? (
												filteredUnits.map((unit) => (
													<button
														type='button'
														key={unit.id}
														onMouseDown={(e) => {
															e.preventDefault();
															handleUnitPick(
																unit,
															);
														}}
														className='block w-full px-3 py-2 text-left text-[14px] text-[#4F5257] hover:bg-[#F3F4F6]'>
														{unit.nome}
													</button>
												))
											) : (
												<div className='px-3 py-2 text-[13px] text-[#9CA3AF]'>
													Nenhuma unidade encontrada
												</div>
											)}
										</div>
									)}
								</div>
							</div>
						)}

						{canShowExportFilter && (
							<div
								className={`w-full items-end content-end ${
									hasGestorLayout
										? 'lg:max-w-[500px] lg:border lg:border-l-gray-300 lg:border-t-0 lg:border-r-0 lg:border-b-0 lg:pl-4'
										: isSubhueReadOnly
											? 'lg:flex-1 lg:pl-6 lg:border-l lg:border-[#E5E7EB]'
											: 'lg:flex-1 lg:pl-4 lg:border-l lg:border-[#E5E7EB]'
								}`}>
								<div className='flex flex-col gap-2'>
									<p className='text-[16px] font-medium text-[#173A67]'>
										{exportTitle}
									</p>
									<div className='flex flex-col gap-3 sm:flex-row sm:items-end sm:gap-2'>
										<div className='flex flex-col rounded-lg w-full '>
											<div className='flex flex-row gap-2 sm:gap-3 justify-between sm:justify-start'>
												<div className='flex flex-col flex-1 sm:flex-none min-w-0'>
													<p className='text-[10px] text-gray-400 font-medium'>
														Data inicial
													</p>
													<input
														type='date'
														id='initialDate'
														value={initialDate}
														onChange={handleDates}
														className='border transition-all duration-300 text-[#a0a0a0] border-gray-300 rounded-lg p-2 text-sm w-full sm:w-[80px] lg:w-[130px] focus:outline-none focus:border-blue-400 focus:ring-1 '
													/>
												</div>
												<div className='hidden sm:flex items-center justify-center'>
													<div className='bg-[#c5c5c5] w-2 h-[2px] mt-4'></div>
												</div>

												<div className='flex flex-col flex-1 sm:flex-none min-w-0'>
													<p className='text-[10px] text-gray-400 font-medium'>
														Data final
													</p>
													<input
														type='date'
														value={finalDate}
														id='finalDate'
														onChange={handleDates}
														className='border transition-all duration-300 text-[#a0a0a0] border-gray-300 rounded-lg p-2 text-sm w-full sm:w-[80px] lg:w-[130px] focus:outline-none focus:border-blue-400 focus:ring-1 '
													/>
												</div>
											</div>
										</div>
										<div className='w-full flex justify-end sm:max-w-[220px]'>
											<button
												onClick={() =>
													handleExcelExport()
												}
												disabled={
													initialDate.length === 0 ||
													finalDate.length === 0
												}
												className='p-[7px] rounded-[7px] enabled:shadow-md border border-gray-200 flex justify-center enabled:text-white font-medium enabled:bg-[#1E6D41] text-shadow-md enabled:hover:bg-[#195a36] transition-all duration-200 gap-2 items-center w-full enabled:border-[#1E6D41] enabled:hover:border-[#195a36] text-gray-200 '>
												<RiFileExcel2Line className='scale-[110%]' />
												Exportar em Excel
											</button>

											{excelAlert === true ? (
												<div className='fixed inset-0 flex items-center justify-center bg-black/50 z-50'>
													<div className='shadow-lg flex flex-col  text-center bg-[#e7e7e7] text-[#a3a3a3] gap-8 font-semibold font-inter w-[350px] h-[180px] px-4  rounded-xl'>
														<div className=''></div>

														<>
															<p className='text-[#a3a3a3] text-lg'>
																{new Date(
																	finalDate,
																) <
																new Date(
																	initialDate,
																)
																	? 'A data final não pode ser menor que a data inicial'
																	: 'O período para exportação não pode ultrapassar 6 meses.'}
															</p>
															<div className='flex justify-center gap-4'>
																<button
																	onClick={() => {
																		setExcelAlert(
																			false,
																		);
																		setFinalDate(
																			'',
																		);
																	}}
																	className='bg-[#004A80] rounded-md p-1 px-5 text-white hover:border-[#1b425e] border-[#004A80] border-[1px] hover:bg-[#1b425e]'>
																	Continuar
																</button>{' '}
															</div>
														</>
													</div>
												</div>
											) : null}
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			) : null}

			{duality ? (
				<div className='grid my-[100px] sm:w-full'>
					<div className='mx-auto w-[90%] max-w-[1136px]'>
						<button
							type='button'
							onClick={() => {
								window.location.reload();
							}}
							className='inline-flex items-center  gap-1.5 text-[18px] font-medium text-[#17395f]  hover:text-[#60758f] duration-300 transition-colors '>
							<MdArrowBackIosNew size={15} />
							Voltar
						</button>
						{/* <button
							className='bg-[#E3E3E3] p-1 text-[#757575] font-semibold mx-auto w-[100px] rounded-md hover:bg-[#757575] transition-all duration-200 hover:text-[#f0f0f0]'
							onClick={() => {
								window.location.reload();
							}}>
							{' '}
							Voltar
						</button> */}
					</div>

					{/* <ClassInvForm
								notificacao={{
									...(propNotes?.notificacao
										? propNotes.notificacao
										: propNotes),
									unidade_nome: propNotes?.unidade_nome,
									protocolo: propNotes?.protocolo,
									status:
										propNotes.status === 'REINVESTIGACAO'
											? 'CLASSIFICADO'
											: propNotes.status,
								}}
								cards={propCard}
							/> */}
					{propCard.viewOnly ? (
						<ReadOnlyIncidentView
							notificacao={{
								...(propNotes?.notificacao
									? propNotes.notificacao
									: propNotes),
								unidade_nome: propNotes?.unidade_nome,
								protocolo: propNotes?.protocolo,
								status:
									propNotes.status === 'REINVESTIGACAO'
										? 'CLASSIFICADO'
										: propNotes.status,
							}}
						/>
					) : (
						<>
					{/* NOTIFICAÇÃO */}
					{{
						status:
							propNotes.status === 'REINVESTIGACAO'
								? 'CLASSIFICADO'
								: propNotes.status,
					}.status === 'NOTIFICADO' &&
						propCard.card === 'NOTIFICADO' &&
						propCard.caso !== 'NOTIFICADO' && (
							<div>
								<NewNotificacao
									notificacao={{
										...(propNotes?.notificacao
											? propNotes.notificacao
											: propNotes),
										unidade_nome: propNotes?.unidade_nome,
										protocolo: propNotes?.protocolo,
										status:
											propNotes.status ===
											'REINVESTIGACAO'
												? 'CLASSIFICADO'
												: propNotes.status,
									}}
									cards={propCard}
								/>
							</div>
						)}
					{/* CLASSIFICAÇÃO */}
					{{
						status:
							propNotes.status === 'REINVESTIGACAO'
								? 'CLASSIFICADO'
								: propNotes.status,
					}.status === 'NOTIFICADO' &&
						propCard.card === 'NOTIFICADO' &&
						propCard.caso === 'NOTIFICADO' && (
							<NewClassificacao
								notificacao={{
									...(propNotes?.notificacao
										? propNotes.notificacao
										: propNotes),
									unidade_nome: propNotes?.unidade_nome,
									protocolo: propNotes?.protocolo,
									status:
										propNotes.status === 'REINVESTIGACAO'
											? 'CLASSIFICADO'
											: propNotes.status,
								}}
								cards={propCard}
							/>
						)}

					{/* INVESTIGAÇÃO */}
					{/* {console.log(propCard, propNotes)} */}
					{{
						status:
							propNotes.status === 'REINVESTIGACAO'
								? 'CLASSIFICADO'
								: propNotes.status,
					}.status === 'CLASSIFICADO' &&
						propCard.card === 'CLASSIFICADO' && (
							<NewInvestigacao
								notificacao={{
									...(propNotes?.notificacao
										? propNotes.notificacao
										: propNotes),
									unidade_nome: propNotes?.unidade_nome,
									protocolo: propNotes?.protocolo,
									status:
										propNotes.status === 'REINVESTIGACAO'
											? 'CLASSIFICADO'
											: propNotes.status,
								}}
								cards={propCard}
							/>
						)}

					{/* AVALIAÇÃO FINAL */}
					{{
						status:
							propNotes.status === 'REINVESTIGACAO'
								? 'CLASSIFICADO'
								: propNotes.status,
					}.status === 'INVESTIGADO' &&
						propCard.card === 'INVESTIGADO' && (
							<NewAvaliacao
								notificacao={{
									...(propNotes?.notificacao
										? propNotes.notificacao
										: propNotes),
									unidade_nome: propNotes?.unidade_nome,
									protocolo: propNotes?.protocolo,
									status:
										propNotes.status === 'REINVESTIGACAO'
											? 'CLASSIFICADO'
											: propNotes.status,
								}}
								cards={propCard}
							/>
						)}

					{/* VISUALIZAÇÃO CONCLUÍDA — todas as etapas + PDF */}
					{{
						status:
							propNotes.status === 'REINVESTIGACAO'
								? 'CLASSIFICADO'
								: propNotes.status,
					}.status === 'CONCLUIDO' &&
						propCard.card === 'CONCLUIDO' && (
							<NewConcludedView
								notificacao={{
									...(propNotes?.notificacao
										? propNotes.notificacao
										: propNotes),
									unidade_nome: propNotes?.unidade_nome,
									protocolo: propNotes?.protocolo,
									status: 'CONCLUIDO',
								}}
							/>
						)}

					{/* <ClassInvForm
								notificacao={{
									...(propNotes?.notificacao
										? propNotes.notificacao
										: propNotes),
									unidade_nome: propNotes?.unidade_nome,
									protocolo: propNotes?.protocolo,
									status:
										propNotes.status === 'REINVESTIGACAO'
											? 'CLASSIFICADO'
											: propNotes.status,
								}}
								cards={propCard}
							/> */}
						</>
					)}
				</div>
			) : (
				<div className='font-inter flex flex-col flex-grow '>
					{showAlert ? (
						<section className='bg-[#004A80] mt-[150px] rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%]  mx-auto my-auto'>
							<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
								<div className='mx-auto max-w-screen-sm text-center'>
									<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
										401
									</h1>
									<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
										Acesso Negado
									</p>
									<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
										Você não possui permissão para acessar
										este campo. Entre em contato com o
										administrador(a) da sua unidade para
										solicitação de acesso.
									</p>
									<a
										href='/login'
										className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center my-4'>
										<span> Volte para a Tela de Login</span>
									</a>
								</div>
							</div>
						</section>
					) : (
						<div>
							<div className='w-[90%] sm:w-[95%] mt-[24px] mx-auto items-center max-w-[1136px] mb-10 flex-grow'>
								{/* CARDS */}
								<div
									className='
    flex flex-wrap
		
    gap-y-8 gap-[24px]
    justify-center
		xl:justify-between
    min-h-[400px]
  '>
									{Object?.keys(icons)?.map((icon, index) => (
										<div
											key={index}
											className='
        flex flex-col justify-between items-center
        bg-[#F5F5F5] shadow-md
        w-[260px]
        p-[16px]
        rounded-lg
        gap-y-[16px]
        min-h-[400px]
        border-[2px]
      '>
											<div className='w-full justify-center grid gap-[18px]'>
												<div className='grid justify-center'>
													<img
														alt='icone do status'
														src={
															icons[`${index}`]
																?.icon
														}
													/>
												</div>
												<div
													className='
            grid text-center text-[#004A80]
            max-w-[180px]
            leading-7
            text-[16px] md:text-[24px]
            font-bold
          '>
													{
														icons[`${index}`]
															?.descrição
													}
												</div>
											</div>

											<div className='w-full text-center grid gap-[16px] h-full'>
												<div className='flex flex-col gap-4'>
													<div className='grid justify-center text-[#004A80] text-[32px] font-bold'>
														{notifyNumbers ? (
															icons[`${index}`]
																?.investigados ? (
																notifyNumbers
																	?.concluidos
																	?.length +
																notifyNumbers
																	?.investigados
																	?.length
															) : (
																notifyNumbers[
																	icons[
																		`${index}`
																	]?.status
																]?.length || '0'
															)
														) : (
															<svg
																aria-hidden='true'
																className='w-8 h-8 text-gray-200 animate-spin   fill-blue-600'
																viewBox='0 0 100 101'
																fill='none'
																xmlns='http://www.w3.org/2000/svg'>
																<path
																	d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
																	fill='currentColor'></path>
																<path
																	d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
																	fill='currentFill'></path>
															</svg>
														)}
													</div>

													<div className='w-full grid gap-[10px]'>
														<div className='bg-[#E3E3E3] h-[2px] w-full'></div>
														<div className='grid justify-center w-full text-[14px] text-[#757575] min-h-[42px]'>
															{icons[`${index}`]
																.status ===
															'concluidos'
																? ''
																: 'Notificações'}{' '}
															{icons[`${index}`]
																.descrição ===
															'Avaliação Final'
																? 'Concluídas'
																: icons[
																		`${index}`
																	].descrição}
														</div>
													</div>
												</div>

												{icons[`${index}`].status ===
													'classificados' ||
												icons[`${index}`].status ===
													'notificados' ||
												icons[`${index}`].status ===
													'investigados' ? (
													<div className='flex gap-[28px] justify-center my-[8px]'>
														<div
															className={`grid ${
																icons[
																	`${index}`
																].concluidos
																	? 'text-[#32993E]'
																	: 'text-[#00C0F3]'
															}`}>
															<div className='grid font-semibold text-[18px] mx-auto'>
																{notifyNumbers ? (
																	notesNoPrazo ===
																	undefined ? (
																		0
																	) : (
																		notesNoPrazo[
																			icons[
																				`${index}`
																			]
																				?.status
																		]
																			?.length
																	)
																) : (
																	<svg
																		aria-hidden='true'
																		className='w-5 h-5 text-gray-200 animate-spin   fill-blue-600'
																		viewBox='0 0 100 101'
																		fill='none'
																		xmlns='http://www.w3.org/2000/svg'>
																		<path
																			d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
																			fill='currentColor'></path>
																		<path
																			d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
																			fill='currentFill'></path>
																	</svg>
																)}
															</div>
															<div className='grid font-normal text-[14px]'>
																{icons[
																	`${index}`
																].noPrazo
																	? 'No Prazo'
																	: 'Concluídas'}
															</div>
														</div>

														<div className='w-[2px] h-full my-auto bg-[#004A80] rounded-lg'></div>

														<div className='grid text-[#B74644]'>
															<div className='grid mx-auto font-semibold text-[18px]'>
																{notifyNumbers ? (
																	notesNoPrazo ===
																	undefined ? (
																		0
																	) : (
																		notifyNumbers[
																			icons[
																				`${index}`
																			]
																				?.status
																		]
																			?.length -
																		notesNoPrazo[
																			icons[
																				`${index}`
																			]
																				?.status
																		]
																			?.length
																	)
																) : (
																	<svg
																		aria-hidden='true'
																		className='w-5 h-5 text-gray-200 animate-spin   fill-blue-600'
																		viewBox='0 0 100 101'
																		fill='none'
																		xmlns='http://www.w3.org/2000/svg'>
																		<path
																			d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
																			fill='currentColor'></path>
																		<path
																			d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
																			fill='currentFill'></path>
																	</svg>
																)}
															</div>
															<div className='grid font-normal text-[14px]'>
																{icons[
																	`${index}`
																].atrasados
																	? 'Em Atraso'
																	: 'Pendentes'}
															</div>
														</div>
													</div>
												) : (
													<div className='flex flex-col items-center justify-between gap-1 w-[80%] mx-auto'>
														{pendentes?.resumo
															?.total_concluidos_com_plano_pendente ===
														0 ? (
															<div>
																<p className='font-normal text-[#00C0F3] text-sm'>
																	Nenhum Plano
																	de Ação
																	Pendente
																</p>
															</div>
														) : (
															<div>
																<div className='font-semibold text-[#B74644] text-xl'>
																	{
																		pendentes
																			?.resumo
																			?.total_concluidos_com_plano_pendente
																	}
																</div>
																<p className='font-normal text-[#B74644] text-sm'>
																	Planos de
																	ação
																	pendentes
																</p>
															</div>
														)}
													</div>
												)}

												<div className='flex items-end'>
													<button
														onClick={() => {
															handleClick(
																icons[
																	`${index}`
																]?.status,
															);
															setInvFilter(false);
															setTempFilters({
																atrasadas: false,
																dataInicio: '',
																dataFim: '',
																concluidos: false,
																pendentes: false,
																plano_acao: false,
																prazo: false,
																rejeitadas: false,
															});
														}}
														className={`
              w-full py-[6px]
              border-[2px]
              transition-all duration-200
              max-h-[36px]
              text-[#757575]
              hover:bg-[#004A80]
              hover:text-[#F5F5F5]
              rounded-lg
              ${
					icons[`${index}`].status
						.slice(0, icons[`${index}`].status.length - 1)
						.toUpperCase() === currentUser.card
						? 'bg-[#004A80] text-[#F5F5F5] border-transparent'
						: 'border-[#757575]'
				}
            `}>
														<div className='flex justify-center gap-[10px]'>
															<IoMdEye className='scale-[110%]' />
															<p className='text-[12px] font-normal'>
																Visualizar
															</p>
														</div>
													</button>
												</div>
											</div>
										</div>
									))}
								</div>
								<div className='w-full h-[1px] bg-[#E3E3E3] my-[28px] '></div>

								{/* LISTA */}
								<div className='border-[2px] border-[#E3E3E3] py-[18px] sm:py-[22px] flex flex-col rounded-lg gap-[22px]'>
									<div className='flex flex-col pr-[16px] sm:pr-[22px] gap-[22px]'>
										<div className='flex flex-col px-[16px] sm:px-[22px] gap-[18px] sm:gap-[22px]'>
											{/* Área de Filtros sempre visível */}
											<div className='flex flex-wrap xl:flex-nowrap w-full items-end gap-3 sm:gap-4'>
												{/* BARRA DE PESQUISA */}
												<div className='flex w-full lg:w-full xl:flex-1 max-h-[40px] justify-start'>
													<input
														type='text'
														placeholder='Pesquisar'
														onChange={(event) =>
															setProtocolFilter(
																event.target
																	.value,
															)
														}
														className='w-full text-[#a7a7a7] font-normal text-[16px] border-[#757575] border-[1px] rounded-lg px-2 py-1 rounded-r-none placeholder:text-[#E3E3E3]'
													/>
													<button
														onClick={() =>
															handleSearchProtocol(
																protocolFilter,
															)
														}
														className='hover:text-[#f3f3f3] transition-all duration-200 hover:bg-[#6d6d6d] text-[#757575] w-[40px] h-[40px] border-[#757575] border-[1px] rounded-lg px-2 py-1 rounded-l-none border-l-0'>
														<div className='flex justify-center items-center h-full w-full'>
															<FaSearch className='w-[20px] h-[20px]' />
														</div>
													</button>
												</div>

												{/* FILTROS DE DATA + CONDICIONAIS */}
												<div className='flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:gap-[12px] items-stretch sm:items-end'>
													<div className='flex w-full gap-2 sm:w-auto sm:gap-[12px]'>
														{/* Data início */}
														<div className='flex flex-col gap-1 flex-1 sm:flex-none min-w-0'>
															<label className='text-[#757575] text-[14px] font-medium'>
																Data início
															</label>
															<input
																type='date'
																value={
																	tempFilters.dataInicio
																}
																onChange={(e) =>
																	setTempFilters(
																		(
																			prev,
																		) => ({
																			...prev,
																			dataInicio:
																				e
																					.target
																					.value,
																		}),
																	)
																}
																className='w-full sm:w-[140px] text-[#757575] text-[14px] border-[#d0d0d0] border-[1px] rounded-lg px-3 py-2'
															/>
														</div>

														{/* Data fim */}
														<div className='flex flex-col gap-1 flex-1 sm:flex-none min-w-0'>
															<label className='text-[#757575] text-[14px] font-medium'>
																Data fim
															</label>
															<input
																type='date'
																value={
																	tempFilters.dataFim
																}
																onChange={(e) =>
																	setTempFilters(
																		(
																			prev,
																		) => ({
																			...prev,
																			dataFim:
																				e
																					.target
																					.value,
																		}),
																	)
																}
																className='w-full sm:w-[140px] text-[#757575] text-[14px] border-[#d0d0d0] border-[1px] rounded-lg px-3 py-2'
															/>
														</div>
													</div>

													{/* FILTROS CONDICIONAIS */}

													{/* FILTROS DROPDOWN */}
													<div
														ref={filtrosRef}
														style={{
															position:
																'relative',
															display:
																'inline-block',
														}}
														className={`w-full sm:w-auto ${
															![
																'CLASSIFICADO',
																'NOTIFICADO',
																'INVESTIGADO',
																'CONCLUIDO',
															].includes(
																currentUser.card,
															)
																? 'hidden'
																: ''
														}`}>
														{/* Botão de Filtros */}
														<button
															onClick={() =>
																setFiltrosOpen(
																	!filtrosOpen,
																)
															}
															style={{
																display: 'flex',
																alignItems:
																	'center',
																gap: '8px',
																padding:
																	'8px 14px',
																height: '40px',
																width: '100%',
																border: '1px solid #ddd',
																borderRadius:
																	'8px',
																backgroundColor:
																	'white',
																cursor: 'pointer',
																fontSize:
																	'14px',
																fontWeight:
																	'500',
																color: '#004A80',
																transition:
																	'all 0.2s ease',
																boxShadow:
																	filtrosOpen
																		? '0 2px 8px rgba(0,0,0,0.1)'
																		: 'none',
															}}>
															{/* Ícone de Filtro */}
															<svg
																width='16'
																height='16'
																viewBox='0 0 16 16'
																fill='none'
																xmlns='http://www.w3.org/2000/svg'
																style={{
																	color: '#757575',
																}}>
																<path
																	d='M2 3.5L6 8.5V13.5L10 15.5V8.5L14 3.5V2H2V3.5Z'
																	stroke='currentColor'
																	strokeWidth='1.5'
																	strokeLinecap='round'
																	strokeLinejoin='round'
																/>
															</svg>

															<span>Filtros</span>

															{/* Badge com contador */}
															{(() => {
																let count = 0;
																if (
																	[
																		'CLASSIFICADO',
																		'NOTIFICADO',
																		'INVESTIGADO',
																	].includes(
																		currentUser.card,
																	)
																) {
																	if (
																		tempFilters.atrasadas
																	)
																		count++;
																	if (
																		tempFilters.prazo
																	)
																		count++;
																} else if (
																	currentUser.card ===
																	'CONCLUIDO'
																) {
																	if (
																		tempFilters.rejeitadas
																	)
																		count++;
																	if (
																		tempFilters.plano_acao
																	)
																		count++;
																}
																return count >
																	0 ? (
																	<span
																		style={{
																			display:
																				'inline-flex',
																			alignItems:
																				'center',
																			justifyContent:
																				'center',
																			minWidth:
																				'20px',
																			height: '20px',
																			padding:
																				'0 6px',
																			backgroundColor:
																				'#004A80',
																			color: 'white',
																			borderRadius:
																				'10px',
																			fontSize:
																				'12px',
																			fontWeight:
																				'600',
																		}}>
																		{count}
																	</span>
																) : null;
															})()}

															{/* Seta */}
															<svg
																width='12'
																height='12'
																viewBox='0 0 12 12'
																fill='none'
																xmlns='http://www.w3.org/2000/svg'
																style={{
																	color: '#757575',
																	transform:
																		filtrosOpen
																			? 'rotate(180deg)'
																			: 'rotate(0deg)',
																	transition:
																		'transform 0.2s ease',
																}}>
																<path
																	d='M2 4L6 8L10 4'
																	stroke='currentColor'
																	strokeWidth='1.5'
																	strokeLinecap='round'
																	strokeLinejoin='round'
																/>
															</svg>
														</button>

														{/* Dropdown */}
														{filtrosOpen && (
															<div
																style={{
																	position:
																		'absolute',
																	top: 'calc(100% + 8px)',
																	left: 0,
																	minWidth:
																		'280px',
																	backgroundColor:
																		'white',
																	border: '1px solid #e5e7eb',
																	borderRadius:
																		'8px',
																	boxShadow:
																		'0 4px 12px rgba(0, 0, 0, 0.1)',
																	padding:
																		'10px',
																	zIndex: 1000,
																}}>
																{[
																	'CLASSIFICADO',
																	'NOTIFICADO',
																	'INVESTIGADO',
																].includes(
																	currentUser.card,
																) ? (
																	<div
																		style={{
																			display:
																				'flex',
																			flexDirection:
																				'column',
																		}}>
																		<label className='flex items-center gap-2 p-2 rounded-md hover:bg-gray-50 cursor-pointer transition-colors'>
																			<input
																				type='checkbox'
																				id='atrasadas'
																				checked={
																					tempFilters.atrasadas
																				}
																				onChange={
																					handleFilters
																				}
																				className='accent-[#757575] h-4 w-4'
																			/>
																			<span className='text-[#004A80] font-medium text-[14px]'>
																				Em
																				atraso
																			</span>
																		</label>
																		<label className='flex items-center gap-2 p-2 rounded-md hover:bg-gray-50 cursor-pointer transition-colors'>
																			<input
																				type='checkbox'
																				id='prazo'
																				checked={
																					tempFilters.prazo
																				}
																				onChange={
																					handleFilters
																				}
																				className='accent-[#757575] h-4 w-4'
																			/>
																			<span className='text-[#004A80] font-medium text-[14px]'>
																				No
																				prazo
																			</span>
																		</label>
																	</div>
																) : (
																	<div
																		style={{
																			display:
																				'flex',
																			flexDirection:
																				'column',
																			gap: '8px',
																		}}>
																		<label className='flex items-center gap-2 p-2 rounded-md hover:bg-gray-50 cursor-pointer transition-colors'>
																			<input
																				type='checkbox'
																				name='concluidas'
																				id='rejeitadas'
																				checked={
																					tempFilters.rejeitadas
																				}
																				onChange={() =>
																					setTempFilters(
																						(
																							prev,
																						) => ({
																							...prev,
																							rejeitadas: true,
																							plano_acao: false,
																						}),
																					)
																				}
																				className='accent-[#757575] h-4 w-4'
																			/>
																			<span className='text-[#004A80] font-medium text-[14px]'>
																				Concluídas
																				na
																				classificação
																			</span>
																		</label>

																		<label className='flex items-center gap-2 p-2 rounded-md hover:bg-gray-50 cursor-pointer transition-colors'>
																			<input
																				type='checkbox'
																				name='concluidas'
																				id='plano_acao'
																				checked={
																					tempFilters.plano_acao
																				}
																				onChange={() =>
																					setTempFilters(
																						(
																							prev,
																						) => ({
																							...prev,
																							plano_acao: true,
																							rejeitadas: false,
																						}),
																					)
																				}
																				className='accent-[#757575] h-4 w-4'
																			/>
																			<span className='text-[#004A80] font-medium text-[14px]'>
																				Plano
																				de
																				Ação
																				Pendente
																			</span>
																		</label>
																	</div>
																)}
															</div>
														)}
													</div>
												</div>

												{/* BOTÕES */}
												<div className='flex gap-2 shrink-0'>
													<button
														onClick={
															handleApplyFilters
														}
														className='bg-[#13335A] hover:bg-[#102b4d] text-white font-medium text-[14px] px-6 py-2 rounded-md h-[40px]'>
														Aplicar Filtros
													</button>
													<button
														onClick={
															handleClearFilters
														}
														className='bg-white hover:bg-[#f5f5f5] text-[#757575] font-medium text-[14px] px-4 py-2 rounded-md border border-[#d0d0d0] h-[40px]'>
														Limpar
													</button>
												</div>
											</div>
										</div>

										<div className='bg-[#dadada] h-[1px] w-[98%] mx-auto'></div>

										<div className='flex gap-[18px]'>
											<div className='w-[8px] h-[25px] bg-[#00C0F3]'></div>
											<p className='text-[#757575] text-[12px] sm:text-[16px]'>
												Notificações{' '}
												{currentUser.card ===
												'CONCLUIDO'
													? ''
													: 'aguardando'}{' '}
												{currentUser.card ===
												'NOTIFICADO'
													? 'classificação'
													: currentUser.card ===
														  'CLASSIFICADO'
														? 'investigação'
														: currentUser.card ===
															  'CONCLUIDO'
															? 'concluidas'
															: 'avaliação final'}
											</p>
										</div>
									</div>

									{(currentFilter.length === 0 &&
										invFilter === true) ||
									currentFilter ===
										'Nenhuma notificação encontrada' ||
									itemsPerPage.length === 0 ? (
										<div className='flex justify-center font-inter font-bold text-[12px] sm:text-xl text-[#bbbbbb] py-10'>
											{!selectedUnit &&
											(JSON.parse(Cookies.get('user'))
												.unidade === 'subhue' ||
												JSON.parse(Cookies.get('user'))
													.cargo === 'desenvolvedor')
												? 'Selecione uma unidade para visualizar as notificações'
												: 'Nenhuma notificação encontrada...'}
										</div>
									) : !listLoading ? (
										<div className='flex-col w-full px-[22px] pr-[28px]'>
											{itemsPerPage?.map(
												(notificacao, index) => (
													<div
														key={index}
														className='w-full'>
														<div className=' w-full flex justify-between'>
															<div className='h-full my-auto mr-[10px] xl:mr-0'>
																<button
																	onClick={() => {
																		goToClassification(
																			currentUser.status,
																			currentUser.card,
																			{
																				...notificacao,
																				permissao: true,
																			},
																		);
																	}}
																	className='bg-white  border-[2px] px-[10px] py-[8px] rounded-md text-[#004A80] gap-[10px] font-semibold flex border-[#004A80]  hover:text-white align-text-middle hover:bg-[#004A80] transition-all duration-200'>
																	{' '}
																	{/* marcos */}
																	<div className='[8px]'>
																		{(() => {
																			const actionIcon =
																				getActionIcon(
																					currentUser.status,
																					currentUser.card,
																					notificacao,
																				);
																			if (
																				actionIcon
																			) {
																				return actionIcon;
																			}
																			const key = `${currentUser.status}-${currentUser.card}`;
																			// Exceção para 'NOTIFICADO-INVESTIGADO' quando notificacao?.status for 'CONCLUIDO'
																			const user =
																				JSON.parse(
																					Cookies.get(
																						'user',
																					),
																				);
																			if (
																				(user.unidade.includes(
																					'subhue',
																				) ||
																					JSON.parse(
																						Cookies.get(
																							'user',
																						),
																					)
																						.unidade ===
																						'sms' ||
																					JSON.parse(
																						Cookies.get(
																							'user',
																						),
																					)
																						.cargo ===
																						'sms' ||
																					user.cargo.includes(
																						'gestor',
																					) ||
																					user.cargo.includes(
																						'usuario',
																					)) &&
																				currentUser.status ===
																					''
																			) {
																				return (
																					<IoMdEye className='scale-[130%]' />
																				);
																			}

																			if (
																				key ===
																					'CLASSIFICADO-CLASSIFICADO' &&
																				!notificacao?.investigadores
																					?.map(
																						(
																							item,
																						) =>
																							item.nome,
																					)
																					.includes(
																						user.nome,
																					) &&
																				/* user.cargo !==
																					'gestor' && */
																				user.cargo !==
																					'desenvolvedor'
																			) {
																				return (
																					<IoMdEye className='scale-[130%]' />
																				);
																			}

																			if (
																				key ===
																					'NOTIFICADO-INVESTIGADO' &&
																				notificacao?.status ===
																					'CONCLUIDO'
																			) {
																				return (
																					<IoMdEye className='scale-[130%]' />
																				);
																			}

																			return (
																				{
																					'NOTIFICADO-CLASSIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'NOTIFICADO-NOTIFICADO':
																						(
																							<HiOutlinePencilSquare className='scale-[180%]' />
																						),
																					'NOTIFICADO-INVESTIGADO':
																						(
																							<LuClipboardCheck className='scale-[180%]' />
																						),
																					'CLASSIFICADO-NOTIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'CLASSIFICADO-INVESTIGADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'CLASSIFICADO-CONCLUIDO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'NOTIFICADO-CONCLUIDO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'CLASSIFICADO-CLASSIFICADO':
																						(
																							<FaSearch className='scale-[120%]' />
																						),
																					'INVESTIGADO-NOTIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'INVESTIGADO-CLASSIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'INVESTIGADO-INVESTIGADO':
																						(
																							<LuClipboardCheck className='scale-[180%]' />
																						),
																				}[
																					key
																				] ||
																				null
																			);
																		})()}
																	</div>
																	<p className='my-auto text-[12px]  hidden sm:block '>
																		{(() => {
																			const actionLabel =
																				getActionLabel(
																					currentUser.status,
																					currentUser.card,
																					notificacao,
																				);
																			if (
																				actionLabel
																			) {
																				return actionLabel;
																			}
																			const key = `${currentUser.status}-${currentUser.card}`;

																			const user =
																				JSON.parse(
																					Cookies.get(
																						'user',
																					),
																				);

																			if (
																				key ===
																					'CLASSIFICADO-CLASSIFICADO' &&
																				!notificacao?.investigadores
																					?.map(
																						(
																							item,
																						) => {
																							return item.nome;
																						},
																					)
																					.includes(
																						user.nome,
																					) &&
																				!atribuidosList
																					.filter(
																						(
																							item,
																						) =>
																							item.protocolo ===
																							notificacao.protocolo,
																					)[0]
																					?.investigadores.map(
																						(
																							inv,
																						) =>
																							inv.nome,
																					)
																					.includes(
																						user.nome,
																					) &&
																				/* 	user.cargo !==
																					'gestor' && */
																				user.cargo !==
																					'desenvolvedor'
																			) {
																				return 'Visualizar';
																			}

																			if (
																				key ===
																					'NOTIFICADO-INVESTIGADO' &&
																				notificacao?.status ===
																					'CONCLUIDO'
																			) {
																				return 'Visualizar';
																			}

																			if (
																				(user.unidade.includes(
																					'subhue',
																				) ||
																					JSON.parse(
																						Cookies.get(
																							'user',
																						),
																					)
																						.unidade ===
																						'sms' ||
																					JSON.parse(
																						Cookies.get(
																							'user',
																						),
																					)
																						.cargo ===
																						'sms' ||
																					user.cargo ===
																						'gestor' ||
																					user.cargo ===
																						'usuario') &&
																				currentUser.status ===
																					''
																			) {
																				return 'Visualizar';
																			}

																			return (
																				{
																					'NOTIFICADO-CLASSIFICADO':
																						'Visualizar',
																					'CLASSIFICADO-CLASSIFICADO':
																						'Investigar',
																					'NOTIFICADO-NOTIFICADO':
																						'Classificar',
																					'NOTIFICADO-INVESTIGADO':
																						'Avaliar',
																					'CLASSIFICADO-NOTIFICADO':
																						'Visualizar',
																					'CLASSIFICADO-INVESTIGADO':
																						'Visualizar',
																					'CLASSIFICADO-CONCLUIDO':
																						'Visualizar',
																					'NOTIFICADO-CONCLUIDO':
																						'Visualizar',
																					'INVESTIGADO-NOTIFICADO':
																						'Visualizar',
																					'INVESTIGADO-CLASSIFICADO':
																						'Visualizar',
																				}[
																					key
																				] ||
																				null
																			);
																		})()}
																	</p>
																</button>
															</div>

															<div className='flex gap-[14px] overflow-x-auto '>
																{currentUser.card ===
																	'CLASSIFICADO' &&
																currentUser.status !==
																	'' ? (
																	<div
																		title='Lista de Investigadores Atribuídos'
																		className={`max-w-[170px] sm:min-w-[100px] flex flex-col text-center justify-center gap-[12px]
																		
																	`}>
																		<p className='text-[#757575] text-[14px] font-normal '>
																			{' '}
																		</p>
																		<div className='text-[#004A80] h-full text-[16px] font-normal content-center items-center'>
																			<div className=''>
																				<button
																					onClick={() => {
																						handleListInvestigators(
																							notificacao?.protocolo,
																						);

																						setInvChanger(
																							invChanger !==
																								notificacao?.protocolo
																								? notificacao?.protocolo
																								: '',
																						);
																					}}
																					className=' items-center  content-center mx-auto align-middle h-full pb-4 flex justify-center '>
																					<MdOutlinePersonSearch className='w-[30px] h-[30px] border-[#004A80] flex justify-start rounded-full p-[2px] border-[2px] hover:text-white hover:bg-[#004A80] duration-300 transition-all' />
																				</button>
																				{notificacao?.protocolo ===
																				invChanger ? (
																					<div className='absolute border-[2px] border-[#d6d6d6] z-20 font-inter rounded-lg w-[400px] h-auto text-[#004A80] bg-white shadow-lg'>
																						<div className='top-0 h-[30px] w-full items-end text-end content-end bg-[#F1F1F1] rounded-t-lg px-2'>
																							<button
																								onClick={() => {
																									setSelectedInv(
																										'',
																									);
																									setInvChanger(
																										'',
																									);
																								}}
																								className='text-[#BDBDBD]
																									text-end mt-[4px] hover:text-[#a8a8a8]'>
																								<IoMdClose className='h-[20px] w-[20px]' />
																							</button>
																						</div>
																						<div className=' h-full w-full '>
																							<div className=' p-4 flex flex-col gap-5 '>
																								<p className='font-semibold text-[18px]'>
																									Investigadores
																									Atribuídos
																								</p>
																								{carregando ===
																								true ? (
																									<div
																										className='flex justify-center min-h-[20px] content-center  items-center my-[50px] w-full '
																										role='status'>
																										<svg
																											aria-hidden='true'
																											className='w-8 h-8 text-gray-200 animate-spin   fill-blue-600'
																											viewBox='0 0 100 101'
																											fill='none'
																											xmlns='http://www.w3.org/2000/svg'>
																											<path
																												d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
																												fill='currentColor'></path>
																											<path
																												d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
																												fill='currentFill'></path>
																										</svg>
																										<span className='sr-only'>
																											Loading...
																										</span>
																									</div>
																								) : (
																									<div className='flex flex-col gap-3'>
																										{!(
																											currentUser.status ===
																												'CLASSIFICADO' &&
																											currentUser.card ===
																												'CLASSIFICADO'
																										) ? (
																											<div className='flex flex-col gap-3 max-h-[250px] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-[#d6d6d6] scrollbar-track-transparent'>
																												{atribuidos?.map(
																													(
																														investigador,
																														index,
																													) =>
																														investigador.ativo ===
																															true && (
																															<div
																																key={
																																	investigador?.nome +
																																	index
																																}
																																className='w-full flex justify-between  pl-2'>
																																<p className='text-[#757575]'>
																																	{
																																		investigador?.nome
																																	}
																																</p>
																																<button
																																	onClick={() => {
																																		handleRemoveInv(
																																			investigador?.username,
																																		);
																																	}}
																																	className='text-[#a12e2e]'>
																																	<MdOutlineDeleteOutline className='w-[28px] h-[28px] p-1 border-[1px] border-[#B9B9B9]  rounded-[7px] hover:text-white hover:bg-[#a12e2e] transition-all  hover:border-[#a12e2e] duration-300' />
																																</button>
																															</div>
																														),
																												)}
																											</div>
																										) : (
																											<div className='flex flex-col gap-3 text-start w-full px-2 max-h-[200px] overflow-y-auto'>
																												{atribuidos?.map(
																													(
																														investigador,
																													) =>
																														investigador?.ativo ===
																															true && (
																															<p className='text-[#757575]'>
																																{
																																	investigador?.nome
																																}
																															</p>
																														),
																												)}
																											</div>
																										)}
																										{currentUser.status ===
																											'NOTIFICADO' && (
																											<div className='flex justify-between gap-3 '>
																												<select
																													disabled={
																														invList.length ===
																														0
																													}
																													onChange={(
																														e,
																													) =>
																														setSelectedInv(
																															e
																																.target
																																.value,
																														)
																													}
																													className={` border-[2px] w-full  rounded-md h-[38px] p-1
																													
																													
																													text-[#757575]
																											
																											${
																												invList.length ===
																												0
																													? 'border-[#d4d4d4] text-[#cfcfcf]'
																													: 'border-[#E3E3E3] text-[#a0a0a0]'
																											}

																											`}>
																													<option
																														value=''
																														hidden>
																														{invList.length ===
																														0
																															? 'Nenhum Investigador Disponivel'
																															: 'Selecione novo  Investigador'}
																													</option>
																													{invList?.map(
																														(
																															inv,
																														) => (
																															<option
																																value={
																																	inv?.username
																																}>
																																{
																																	inv?.nome
																																}
																															</option>
																														),
																													)}
																												</select>

																												<button
																													className='border-[1px] h-[29px] w-[31px] p-1  rounded-full  my-auto transition-all duration-300
																											text-[#757575]
																											enabled:text-[#ffffff] enabled:bg-[#004A80] 
																											enabled:border-none
																											enabled:hover:text-white enabled:hover:bg-[#003d68] '
																													disabled={
																														selectedInv.length ===
																														0
																													}
																													onClick={() => {
																														handleAddInv(
																															selectedInv,
																														);
																													}}>
																													<FiPlus
																														className='w-full h-auto'
																														/* 	className={`border-[1px] h-[28px] w-[28px]  rounded-full p-1 my-auto  transition-all duration-300 `} */
																													/>
																												</button>
																											</div>
																										)}
																									</div>
																								)}
																								{currentUser.status ===
																									'NOTIFICADO' && (
																									<button
																										onClick={() => {
																											handleSendInvChanges();
																											handleClick(
																												currentUser.card ===
																													'CLASSIFICADO'
																													? 'classificados'
																													: currentUser.card ===
																														  'INVESTIGADO'
																														? 'investigados'
																														: currentUser.card ===
																															  'NOTIFICADO'
																															? 'notificados'
																															: null,
																											);
																										}}
																										disabled={
																											changesDone ===
																											true
																										}
																										style={{
																											boxShadow:
																												'2px 2px 3px -1px rgba(0,0,0.2,0.2)',
																										}}
																										className='text-[#f0f0f0] border-[1px] px-[20px] py-[4px] mx-auto font-normal w-[132px]  border-[#e4e4e4]
																									enabled:hover:border-[#004A80] enabled:text-[#929292] rounded-md enabled:hover:bg-[#004A80] enabled:hover:text-white transition-all duration-300 my-auto '>
																										Enviar
																									</button>
																								)}
																								{changesDone ===
																									true && (
																									<p className='text-green-500'>
																										{' '}
																										Alterações
																										Concluidas{' '}
																									</p>
																								)}
																							</div>
																						</div>
																					</div>
																				) : null}
																			</div>
																		</div>
																	</div>
																) : currentUser.card ===
																		'NOTIFICADO' &&
																  currentUser.status ===
																		'NOTIFICADO' ? (
																	<div
																		title='Solicitação de Exclusão da Notificação'
																		className={`max-w-[170px] sm:min-w-[100px] flex flex-col text-center justify-center gap-[12px] hidden

																 `}>
																		{/* EXCLUIR NOTIFICAÇÃO */}
																		<p className='text-[#757575] text-[14px] font-normal '>
																			{' '}
																		</p>
																		<div className='text-[#004A80] h-full text-[16px] font-normal content-center items-center'>
																			<div className=''>
																				<button
																					onClick={() => {
																						setSelectedDelet(
																							selectedDelet ===
																								notificacao.protocolo
																								? ''
																								: notificacao.protocolo,
																						);
																					}}
																					className=' items-center  content-center mx-auto align-middle h-full pb-4 flex text-[#a12e2e] justify-center '>
																					<MdOutlineDeleteOutline className='w-[32px] h-[32px] border-[#B9B9B9] flex justify-start rounded-full p-[3px] border-[2px] hover:text-white hover:bg-[#a12e2e] hover:border-[#a12e2e] duration-300 transition-all' />
																				</button>
																				{notificacao?.protocolo ===
																				selectedDelet ? (
																					<div className='absolute border-[2px] border-[#d6d6d6] z-20 font-inter rounded-lg w-[400px] h-auto text-[#004A80] bg-white shadow-lg'>
																						<div className='top-0 h-[30px] w-full items-end text-end content-end bg-[#F1F1F1] rounded-t-lg px-2'>
																							<button
																								onClick={() => {
																									setSelectedDelet(
																										'',
																									);
																								}}
																								className='text-[#BDBDBD]
																 								text-end mt-[4px] hover:text-[#a8a8a8]'>
																								<IoMdClose className='h-[20px] w-[20px]' />
																							</button>
																						</div>
																						<div className=' h-full w-full '>
																							<div className=' p-4 flex flex-col gap-10 '>
																								<p className='font-semibold text-[18px]'>
																									Solicitar
																									Exclusão
																									da
																									Notificação
																								</p>
																								{carregando ===
																								true ? (
																									<div
																										className='flex justify-center min-h-[20px] content-center  items-center my-[50px] w-full '
																										role='status'>
																										<svg
																											aria-hidden='true'
																											className='w-8 h-8 text-gray-200 animate-spin   fill-blue-600'
																											viewBox='0 0 100 101'
																											fill='none'
																											xmlns='http:www.w3.org/2000/svg'>
																											<path
																												d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
																												fill='currentColor'></path>
																											<path
																												d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
																												fill='currentFill'></path>
																										</svg>
																										<span className='sr-only'>
																											Loading...
																										</span>
																									</div>
																								) : (
																									<div className='text-start'>
																										Descreva
																										o
																										motivo
																										da
																										solicitação
																										<textarea
																											onChange={(
																												e,
																											) =>
																												setMotivoDelet(
																													e
																														.target
																														.value,
																												)
																											}
																											placeholder='mínimo de 3 caractéres'
																											className='border-[2px] border-[#E3E3E3] rounded-md p-2 w-full h-[100px] resize-none text-[#757575]'></textarea>
																									</div>
																								)}
																								{currentUser.status ===
																									'NOTIFICADO' && (
																									<button
																										onClick={() => {
																											motivoDelet.length >
																											3
																												? console.log(
																														'Solicitação Enviada',
																													)
																												: console.log(
																														'Preencha o motivo da solicitação',
																													);
																										}}
																										disabled={
																											motivoDelet.length <
																											3
																										}
																										style={{
																											boxShadow:
																												'2px 2px 3px -1px rgba(0,0,0.2,0.2)',
																										}}
																										className='text-[#f0f0f0] border-[1px] px-[20px] py-[4px] mx-auto font-normal w-[180px]  border-[#e4e4e4]
																 								enabled:hover:border-[#004A80] enabled:text-[#929292] rounded-md enabled:hover:bg-[#004A80] enabled:hover:text-white transition-all duration-300 my-auto '>
																										Enviar
																										Solicitação
																									</button>
																								)}
																								{changesDone ===
																									true && (
																									<p className='text-green-500'>
																										{' '}
																										Alterações
																										Concluidas{' '}
																									</p>
																								)}
																							</div>
																						</div>
																					</div>
																				) : null}
																			</div>
																		</div>
																	</div>
																) : null}

																<div className=' flex flex-col justify-center min-w-[96px] text-center gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Notificação
																	</p>
																	<p className='text-[#004A80] text-[16px] font-normal'>
																		{' '}
																		{
																			notificacao.protocolo
																		}
																	</p>
																</div>
																<div className=' h-[100%] content-center'>
																	<div className='w-[1px]  h-[45px]  bg-[#E3E3E3] '></div>
																</div>
																<div className=' flex flex-col text-center justify-center gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Data da
																		ocorrência
																	</p>
																	<p className='text-[#004A80] text-[16px] font-normal'>
																		{(() => {
																			try {
																				const data =
																					notificacao?.data_ocorrencia ||
																					notificacao
																						?.notificacao
																						?.data_ocorrencia;

																				if (
																					!data
																				)
																					throw new Error();
																				return data
																					.split(
																						'-',
																					)
																					.reverse()
																					.join(
																						'/',
																					);
																			} catch {
																				return 'Data inválida';
																			}
																		})()}
																	</p>
																</div>
																{/* 	{console} */}
																<div className=' h-[100%] content-center '>
																	<div className='w-[1px] h-[45px] my-[20%] bg-[#E3E3E3] '></div>
																</div>
																<div className=' flex flex-col justify-center text-center gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Incidente
																	</p>

																	<p className='text-[#004A80] max-w-[171px] sm:min-w-[171px] leading-[19.2px] text-[16px] font-normal'>
																		{(() => {
																			try {
																				return getIncidentDisplay(
																					notificacao,
																				);
																			} catch {
																				return 'Tipo Invalido';
																			}
																		})()}
																	</p>
																</div>
																<div className=' h-[100%] content-center '>
																	<div className='w-[1px] h-[45px] my-[20%] bg-[#E3E3E3] '></div>
																</div>
																<div className=' flex flex-col text-center justify-center w-[110px] gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal '>
																		{' '}
																		Envolve
																		paciente
																	</p>
																	<p className='text-[#004A80] max-w-[130px] leading-[19.2px] text-[16px] font-normal break-words'>
																		{' '}
																		{notificacao?.nome_paciente
																			? notificacao?.nome_paciente !==
																				''
																				? 'Sim'
																				: 'Não'
																			: notificacao
																						?.notificacao
																						?.envolve_paciente
																				? 'Sim'
																				: 'Não'}
																	</p>
																</div>
																<div className=' h-[100%] content-center'>
																	<div
																		className={`w-[1px] h-[45px] my-[20%] bg-[#E3E3E3] 
																			
																		
																		`}></div>
																</div>
																<div
																	className={`max-w-[170px] sm:min-w-[100px] flex flex-col text-center justify-center gap-[12px]
																		/*  */
																	
																	`}>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Turno
																	</p>
																	<p className='text-[#004A80] text-[16px] font-normal'>
																		{notificacao
																			?.notificacao
																			?.turno_display
																			? notificacao
																					?.notificacao
																					?.turno_display
																			: notificacao?.turno
																				? notificacao?.turno_display
																				: notificacao
																						?.notificacao
																						?.turno_display}
																	</p>
																</div>
																<div className=' h-[100%] content-center'>
																	<div className='w-[1px] h-[45px] my-[20%] bg-[#E3E3E3]'></div>
																</div>
																<div className='flex flex-col text-center justify-center gap-[12px] min-w-[110px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Status
																	</p>

																	<div
																		className={`px-[8px] rounded-full justify-center flex gap-2 py-[2px] ${
																			{
																				pendente:
																					'bg-[#FFE4E3] text-[#B74644]',
																				'Em atraso':
																					'bg-[#FFE4E3] text-[#B74644]',
																				'No prazo':
																					'bg-[#E3F2FF] text-[#2A6BBF]',
																				Concluido:
																					'bg-[#E4FFE3] text-[#44B746]',
																			}[
																				notificacao?.status ===
																				'CONCLUIDO'
																					? 'Concluido'
																					: notificacao?.status ===
																								'CLASSIFICADO' ||
																						  notificacao?.status ===
																								'REINVESTIGACAO'
																						? notesNoPrazo?.classificados?.some(
																								(
																									n,
																								) =>
																									n.protocolo ===
																									notificacao.protocolo,
																							)
																							? 'No prazo'
																							: 'Em atraso'
																						: notificacao?.status ===
																							  'NOTIFICADO'
																							? notesNoPrazo?.notificados?.some(
																									(
																										n,
																									) =>
																										n.protocolo ===
																										notificacao.protocolo,
																								)
																								? 'No prazo'
																								: 'Em atraso'
																							: notificacao?.status ===
																								  'INVESTIGADO'
																								? notesNoPrazo?.investigados?.some(
																										(
																											n,
																										) =>
																											n.protocolo ===
																											notificacao.protocolo,
																									)
																									? 'No prazo'
																									: 'Em atraso'
																								: 'Em atraso'
																			]
																		}`}>
																		<div className='flex gap-2 '>
																			<div className='items-center content-center'>
																				<GoDotFill />
																			</div>
																			<p className='content-center flex items-center text-[15px] py-1'>
																				{notificacao?.status ===
																				'CONCLUIDO'
																					? 'Concluido'
																					: notificacao?.status ===
																								'CLASSIFICADO' ||
																						  notificacao?.status ===
																								'REINVESTIGACAO'
																						? notesNoPrazo?.classificados?.some(
																								(
																									n,
																								) =>
																									n.protocolo ===
																									notificacao.protocolo,
																							)
																							? 'No prazo'
																							: 'Em atraso'
																						: notificacao?.status ===
																							  'NOTIFICADO'
																							? notesNoPrazo?.notificados?.some(
																									(
																										n,
																									) =>
																										n.protocolo ===
																										notificacao.protocolo,
																								)
																								? 'No prazo'
																								: 'Em atraso'
																							: notificacao?.status ===
																								  'INVESTIGADO'
																								? notesNoPrazo?.investigados?.some(
																										(
																											n,
																										) =>
																											n.protocolo ===
																											notificacao.protocolo,
																									)
																									? 'No prazo'
																									: 'Em atraso'
																								: 'Em atraso'}
																			</p>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className='bg-[#dadada] h-[1px] w-full my-[32px]'></div>
													</div>
												),
											)}
										</div>
									) : (
										<Loading />
									)}
									{/* SETA ANTERIOR */}

									{itemsPerPage.length > 0 && (
										<div className='flex justify-center scale-[50%] sm:scale-[80%] gap-[10px] my-[20px]'>
											{/* Botão Anterior */}
											<button
												disabled={currentPage === 1}
												className='font-inter gap-3 hover:text-[#636363] text-[#757575] items-center flex text-[18px] disabled:opacity-50'
												onClick={() =>
													currentPage !== 1 &&
													handlePaginate({
														target: {
															id: currentPage - 1,
														},
													})
												}>
												<div className='h-full items-center align-middle content-center'>
													<FaArrowLeft />
												</div>
												Anterior
											</button>

											{/* Números de Página */}
											{(() => {
												const totalPages = Math.ceil(
													(currentFilter.length > 0 &&
													currentFilter !==
														'Nenhuma notificação encontrada'
														? currentFilter
														: notes
													).length / 10,
												);

												// Função para gerar a estrutura da paginação (igual ao exemplo que você mandou)
												const getPaginas = () => {
													const paginas = [];

													if (totalPages <= 5) {
														for (
															let i = 1;
															i <= totalPages;
															i++
														)
															paginas.push(i);
													} else {
														if (currentPage <= 3) {
															paginas.push(
																1,
																2,
																3,
																'...',
																totalPages,
															);
														} else if (
															currentPage >=
															totalPages - 2
														) {
															paginas.push(
																1,
																'...',
																totalPages - 2,
																totalPages - 1,
																totalPages,
															);
														} else {
															paginas.push(
																1,
																'...',
																currentPage,
																'...',
																totalPages,
															);
														}
													}

													return paginas;
												};

												return getPaginas().map(
													(num, i) =>
														num === '...' ? (
															<span
																key={i}
																className='px-2 text-[#757575] text-[18px]'>
																...
															</span>
														) : (
															<button
																key={i}
																onClick={
																	handlePaginate
																}
																id={num.toString()}
																className={`w-[34px] h-[32px] transition-all duration-300 rounded-lg ${
																	num ===
																	currentPage
																		? 'bg-[#004A80] text-white hover:bg-[#204158]'
																		: 'text-[#757575] hover:bg-[#f0f0f0]'
																}`}>
																{num}
															</button>
														),
												);
											})()}
											{/* Botão Próxima */}
											<button
												disabled={
													currentPage ===
													Math.ceil(
														(currentFilter.length >
															0 &&
														currentFilter !==
															'Nenhuma notificação encontrada'
															? currentFilter
															: notes
														).length / 10,
													)
												}
												className='font-inter items-center flex text-[18px] text-[#757575] hover:text-[#636363] gap-3 disabled:opacity-50'
												onClick={() => {
													const totalPages =
														Math.ceil(
															(currentFilter.length >
																0 &&
															currentFilter !==
																'Nenhuma notificação encontrada'
																? currentFilter
																: notes
															).length / 10,
														);
													if (
														currentPage < totalPages
													) {
														handlePaginate({
															target: {
																id:
																	currentPage +
																	1,
															},
														});
													}
												}}>
												Próxima
												<div className='h-full items-center align-middle content-center'>
													<FaArrowRight />
												</div>
											</button>
										</div>
									)}
								</div>
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
}

export default NotesAvaliation;
